 <template>
  <div class="home_body" ref="firstWrapper">
      <el-dialog
  :title="$t('other.a1346')"
  :visible.sync="soltstatus"
  width="80%"
  >
  <div class="order_Box">
          <div v-if="childrenModel == ''" class="no_data">
              <span class="desc" >{{$t('other.a1347')}}</span>
              
          </div>
          <div v-else class="item_wrapper" >
              <div  class="item_header_wrapper" >
              <!-- <div class="item_header">
                  <span class="header_item" @click="editor(item,0)">{{$t('other.a238')}}</span>
                  <span class="header_item" @click="deleteItemw(item,indexOne,index)">{{$t('other.a312')}}</span>
                 
              </div> -->
              <div class="main_content">
                  <div class="item_left">
                      <div class="pic_box">
                      <img style="width:100%" :src="childrenModel.images[0].image">
                        </div>
                        <div class="item_name">
                            {{childrenModel.name}}
                        </div>
                  </div>
                   <div class="item_center">
                       <div>{{$t('other.a1348')}}：{{childrenModel.isPreOrder ? $t('other.a191') : $t('other.a192')}}</div>
                       <div>{{$t('other.a1349')}}:{{childrenModel.stock}}</div>
                       <div>{{$t('other.a1350')}}：{{childrenModel.sales}}</div>
                       <div>{{$t('other.a360')}}：{{childrenModel.status}}</div>
                   </div>
              </div>

               <div  v-show="children.country === siteValue || siteValue == 'all'"  class="main_content chilrder_content" v-for="(children,index03) in childrenModel.children" :key="index03">
                       <div class="item_center">
                           <div>
                               <div class="desc_item">
                                   <div>
                                    <el-checkbox class="header_item" @change="target(1)" v-model="children.checked02"></el-checkbox>
                                    <span style="padding:0 10px">
                                        <span v-if="children.status == 'DXS'">{{$t('other.a1295')}}</span>
                                        {{children.country | capitalize}}：{{children.productId}}
                                    </span>
                                   </div>
                                </div>
                                <div class="desc_item" v-if="children.status=='DXS'">
                                    <span style="margin:0 5px" v-show="!children.online" class="iconItem_copy"></span>
                                    <span style="margin:0 5px" v-show="children.online" class="iconItem"></span>
                                    <span>{{children.online  ? $t('other.a1353') : $t('other.a1354')}}</span>
                                    
                                </div>
                                <div class="desc_item" v-for="(shopItem,shopIndex) in children.productShops" :key="shopIndex">
                                    <div class="desc_item_first">
                                        <!-- <span>{{showCountry(shopItem.shopId,children.country)}}</span> -->
                                        <span>
                                            <span style="margin:0 5px" v-show="shopItem.publishNum == 0" class="iconItem_copy"></span>
                                            <span style="margin:0 5px" v-show="shopItem.publishNum !== 0" class="iconItem"></span>
                                            <span>{{shopItem.publishNum == 0  ? $t('other.a1354') : $t('other.a1353')}}</span>
                                        </span>
                                    </div>
                                    <!-- <div v-show="shopItem.publishNum !== 0">
                                        <span>商品编码：<span class="item_id" @click="toVeiwId(shopItem)">{{shopItem.itemId ? shopItem.itemId : ''}}</span></span>
                                        <span style="padding:0 10px">{{$t('other.a55')}}：{{shopItem.status ? shopItem.status  : '' | productStatus}}</span>
                                    </div> -->
                                </div>
                           </div>
                           <div>
                               <span class="edito_wrapper" @click="editorChildren(children)">{{$t('other.a238')}}</span>
                               <span class="edito_wrapper" @click="publishProduce(children)">{{$t('other.a1355')}}</span>
                               <span class="edito_wrapper" @click="copyModel(item,children)">{{$t('other.a1356')}}</span>
                               <span class="edito_wrapper" @click="dropdonw(children,indexOne,index03)">{{$t('other.a1292')}}</span>
                               <span class="edito_wrapper" @click="deleteItemwCopy(children,indexOne,index03)">{{$t('other.a312')}}</span>
                                <span class="edito_wrapper" v-if="!children.editorSku" @click="children.editorSku =true,children.numType=children.variations.length">{{$t('other.a93')}}</span>
                                <span class=" changeBox" v-if="children.editorSku" @click="changeItem(children,index03)">{{$t('other.a38')}}</span>
                                <span class=" changeBox" v-if="children.editorSku" @click="children.editorSku =false,children.numType=4">{{$t('other.a146')}}</span>
                           </div>
                       </div>
                    <div class="item_left">
                      <div class="pic_box">
                      <img style="width:100%" :src="children.images[0] ? children.images[0].image : null">
                        </div>
                        <div class="item_name" @dblclick="fixValue(children,children.No)" >
                            <span v-if="!children.editorSku">{{children.name}}</span>
                            <el-input
                            v-else
                            type="textarea"
                            ref="children"
                            :autosize="{ minRows: 2, maxRows: 8}"
                            :placeholder="$t('other.a319')"
                            @blur="saveChildere(children)"
                            v-model="children.name">
                            </el-input>
                        </div>
                    </div>
                   
                  <div class="item_right">
                      <div class="ttp" >
                          <div class="ttp_item">{{$t('other.a335')}}：</div>
                          <div class="ttp_item" v-if="children.tiers[1]">{{$t('other.a1357')}}：</div>
                          <div class="ttp_item">{{$t('other.a310')}}：</div>
                          <div class="ttp_item">{{$t('other.a1275')}}：</div>
                      </div>
                      <div class="ttp" @dblclick="editorSku(children)" v-show="children.variations.length && index09 < children.numType" v-for="(ttp,index09) in children.variations" :key="index09">
                          <div class="ttp_item">
                              <div v-if="!children.editorSku && children.tiers.length">{{children.tiers[0].optionArray[ttp.tierIndex[0]]}}</div>
                              <div v-else><el-input type="text" v-model="children.tiers[0].optionArray[ttp.tierIndex[0]]"></el-input></div>
                          </div>
                          <div class="ttp_item" v-if="children.tiers[1]">
                              <div v-if="!children.editorSku"> {{children.tiers[1].optionArray[ttp.tierIndex[1]]}}</div>
                              <div v-else><el-input type="text" v-model="children.tiers[1].optionArray[ttp.tierIndex[1]]"></el-input></div>
                          </div>
                          <div class="ttp_item">
                            <div v-if="!children.editorSku">{{children.variations.length ? ttp.stock : children.itemSku}}</div>
                            <div v-else><el-input type="text" v-model="ttp.stock"></el-input></div>
                          </div>

                         <div class="ttp_item">
                            <div v-if="!children.editorSku">{{children.variations.length ? ttp.price : children.itemSku}}</div>
                            <div v-else><el-input type="text" v-model="ttp.price"></el-input></div>
                         </div>
                      </div>
                      <div class="ttp" v-show="!children.variations.length" >
                          <div v-if="!children.editorSku" class="ttp_item">{{children.itemSku}}</div>
                          <div v-else><el-input type="text" v-model="children.itemSku"></el-input></div>
                       
                          <div v-if="!children.editorSku" class="ttp_item">{{children.stock}}</div>
                          <div v-else><el-input type="text" v-model="children.stock"></el-input></div>
                          <div v-if="!children.editorSku"  class="ttp_item">{{children.price}}</div>
                          <div v-else><el-input type="text" v-model="children.price"></el-input></div>
                      </div>
                      <div style="text-align:center;color:#409EFF;cursor: pointer;" v-show="children.numType ==4 && children.variations.length > 4" @click="children.numType= children.variations.length "> 
                          {{$t('other.a1197')}} （{{$t('other.a1199')}}{{children.variations.length-4}}{{$t('other.a1337')}}sku）
                      </div>
                      <div style="text-align:center;color:#409EFF;cursor: pointer;" v-show="children.numType !== 4  && children.variations.length" @click="children.numType= 4 "> 
                        {{$t('other.a1358')}}
                      </div>
                      <!-- <div class="btn" v-if="children.editorSku" >
                         <el-button type="danger" @click="saveChildere(children)">{{$t('other.a216')}}</el-button>
                         <el-button type="primary" @click="children.editorSku =false">{{$t('other.a106')}}</el-button>
                      </div> -->
                  </div>
              </div>
              
          
              </div>
          

          </div>
          
    </div>
  <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="soltstatus = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="soltstatus = false">{{$t('other.a279')}}</el-button>
  </span> -->
</el-dialog>
    <el-dialog
  :title="$t('other.a285')"
  :visible.sync="release"
  width="80%"
  >
  <div class="productionModel">
    <div class="basic_info">
        <div class="title">
                <el-tabs v-model="activeName"  @tab-click="getCategory()" class="activecss">
                    <el-tab-pane :label="ccp.label" :name="ccp.value" v-for="(ccp,index) in sitelist" :key="index"></el-tab-pane>
                </el-tabs>
      </div>
    </div>
    
      <div v-show=" activeName !== 'ROOT'  && activeName !== 'DXS' " class="basic_info">
            <div class="title" ref="shopAndCategory">{{$t('other.a1377')}}</div>
            <div class="basic_detail">
                <el-form  :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item  :label="$t('other.a1359')" prop="name">
                         <el-select style="width:100%" v-model="targetShopId" @change="getShopId()"   multiple :placeholder="$t('other.a50')">
                            <el-option
                            v-for="item in shopOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>

                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item :label="$t('other.a1360')" prop="name">
                         <el-select style="width:160px" v-model="ruleForm.status"  :placeholder="$t('other.a50')">
                            <el-option
                            v-for="item in statusOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item :label="$t('other.a1285')"  prop="name">
                        <div v-clickOutSide="handleClose">
                            <el-input v-model="categories" :placeholder="$t('other.a1285')" @focus="showCaetgory=!showCaetgory"></el-input>
                            <div v-if="showCaetgory" class="cateGory_wrapper"  >
                                <ul  class="first_wrapper">
                                    <div class="category_title">{{$t('other.a482')}}</div>
                                    <li class="first_category active" v-for="(item,index) in categoryList" :key="index" @click="cateGory(item,1)">
                                        <span>{{item.categoryName}} </span>
                                    </li>
                                </ul>
                                <ul v-if="secondCategory.length"  class="second_wrapper">
                                    <div class="category_title">{{$t('other.a483')}}</div>
                                    <li class="second_category  active" v-for="(itemTwo,indexOne) in secondCategory" :key="indexOne" @click="cateGory(itemTwo,2)">
                                    <span> {{itemTwo.categoryName}} </span>
                                    </li>
                                </ul>
                                <ul v-if="thiryCategory.length"  class="three_wrapper">
                                    <div class="category_title">{{$t('other.a484')}}</div>
                                    <li class="three_category  active" v-for="(itemThree,indexOne) in thiryCategory" :key="indexOne" @click="cateGory(itemThree,3)">
                                        <span>{{itemThree.categoryName}}</span>
                                    </li>
                                </ul>

                                <ul v-if="fourCategory.length"  class="four_wrapper">
                                    <div class="category_title"> {{$t('other.a1378')}}</div>
                                    <li class="four_category  active" v-for="(itemfour,indexOne) in fourCategory" :key="indexOne" @click="cateGory(itemfour,4)">
                                        {{itemfour.categoryName}}
                                    </li>
                                </ul>
                                <ul v-if="fiveCategory.length"  class="five_wrapper">
                                    <div class="category_title"> {{$t('other.a1379')}}</div>
                                    <li class="five_category  active" v-for="(itemfive,indexOne) in fiveCategory" :key="indexOne" @click="cateGory(itemfive,5)">
                                        {{itemfive.categoryName}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item   :label="$t('other.a1361')" >
                          <el-form-item v-for="(item,index) in attributes" :key="index"  :prop="item.is_mandatory ? 'isMandatory' : 'notMandatory' " >
                              <div style="font-weight:bold">
                                  <i v-if="item.is_mandatory" style="color:red;font-size:20px">*</i>{{item.attribute_name}}：
                              </div>
                              <div>
                                <el-select style="width:250px" class="attribute"  ref="searchSelect" filterable v-if="item.input_type == 'COMBO_BOX'" v-el_selectLoadmore:addRangeNumber="loadMore()" @input.native="findItem(item,index)"  v-model="item.userValue" filterable  @change="pushAttribute()"  :placeholder="$t('other.a50')">
                                    <el-option
                                    v-for="item in item.options.slice(0,rangeNumber)"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                    </el-option>
                                </el-select>
                                <!-- 选择单位 -->
                                <el-select style="width:150px"  ref="searchSelect" filterable v-if="item.input_type == 'COMBO_BOX' && item.unit_list"  v-el_selectLoadmore:addRangeNumber="loadMore()" @input.native="findItem(item,index)"  v-model="item.unit" filterable  @change="pushAttribute()"  :placeholder="$t('other.a1362')">
                                    <el-option
                                    v-for="item in item.unit_list"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                    </el-option>
                                </el-select>
                                
                                <el-select style="width:250px" class="attribute" ref="searchSelect" v-if="item.input_type == 'DROP_DOWN'" v-el_selectLoadmore:addRangeNumber="loadMore()" @input.native="findItem(item,index)"  v-model="item.userValue" filterable  @change="pushAttribute()"  :placeholder="$t('other.a50')">
                                    <el-option
                                    v-for="item in item.options.slice(0,rangeNumber)"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                    </el-option>
                                </el-select>
                                <!-- 选择单位 -->
                                <el-select style="width:150px" ref="searchSelect" v-if="item.input_type == 'DROP_DOWN' && item.unit_list" v-el_selectLoadmore:addRangeNumber="loadMore()" @input.native="findItem(item,index)"  v-model="item.unit" filterable  @change="pushAttribute()"  :placeholder="$t('other.a1362')">
                                    <el-option
                                    v-for="item in item.unit_list"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                    </el-option>
                                </el-select>


                                <el-input style="width:250px"  v-if="item.input_type == 'TEXT_FILED' " class="attribute"   v-model="item.userValue" :placeholder="$t('other.a298')" @change="pushAttribute()"></el-input>

                                <el-select style="width:150px" ref="searchSelect" v-if="item.input_type == 'TEXT_FILED' && item.unit_list" v-el_selectLoadmore:addRangeNumber="loadMore()" @input.native="findItem(item,index)"  v-model="item.unit" filterable  @change="pushAttribute()"  :placeholder="$t('other.a1362')">
                                    <el-option
                                    v-for="item in item.unit_list"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                    </el-option>
                                </el-select>
                              </div>
                            </el-form-item>
                    </el-form-item>
                    

                     <el-form-item  :label="$t('other.a1363')" >
                        <div>
                          <el-radio v-model="ruleForm.condition" label='NEW'>{{$t('other.a1380')}}</el-radio>
                          <el-radio v-model="ruleForm.condition" label="USED">{{$t('other.a1381')}}</el-radio>
                        </div>
                        
                    </el-form-item>

                   
                </el-form>

                
            </div>
        </div>
       <div class="basic_info" ref="bascInfo">
            <div class="title">{{$t('other.a1239')}}</div>
            <div class="basic_detail">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item :label="$t('other.a1364')" v-if="activeName == 'DXS'" prop="name">
                        <el-select style="width:250px" ref="searchSelect"    v-model="ruleForm.country"   :placeholder="$t('other.a644')">
                            <el-option
                            v-for="item in countryOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                     <el-form-item :label="$t('other.a1365')" v-if="ruleForm.sourceUrl" prop="name">
                        <el-input
                        type="textarea"
                        autosize
                        :placeholder="$t('other.a319')"
                        v-model="ruleForm.sourceUrl">
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('other.a179')" prop="name">
                        <el-input
                        type="textarea"
                        autosize
                        :placeholder="$t('other.a319')"
                        v-model="ruleForm.name">
                        </el-input>
                    </el-form-item>
                     <el-form-item :label="$t('other.a1241')" prop="description">
                        <el-input
                        type="textarea"
                        autosize
                        :placeholder="$t('other.a319')"
                        v-model="ruleForm.description">
                        </el-input>
                    
                    </el-form-item>
                    
                </el-form>
            </div>
        </div>
        <div class="basic_info">
            <div class="title" ref="photo">{{$t('other.a1265')}}</div>
            <div class="basic_detail">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item :label="$t('other.a1242')" prop="name">
                        <draggable
                        class=""
                        v-model="ruleForm.images"
                        tag='ul'
                        v-bind="dragOptions"
                        @start="ruleForm.drag = true"
                        @end="ruleForm.drag = false"
                        >
                        <span v-for="(item,index) in ruleForm.images" :key="index"  :class="{'listitem':true,}"  @click="showDelBtn(index)"  @mouseenter="indexOne=index" @mouseleave="indexOne =-1">
                      
                            <img v-show="item.image"  :src="item.image"  class="pic_box">
                            <div v-show="item.image" :class="{'delete':true,'deleteActive':indexOne == index}" @click.stop="deleteImg(index)">{{$t('other.a312')}}</div>
                            <span class="pic_desc">{{index == 0 ? $t('other.a1266') : $t('other.a66')+index}}</span>
                        </span>
                        </draggable>
                               <el-upload 
                            
                                action=""
                                multiple
                                style="filter:alpha(opacity=0);opacity:0;"
                                list-type="picture-card"
                                :http-request="handleUploadHttpRequest"
                                :on-success="handlePictureSuccess"
                                :show-file-list="false">
                                <el-button id="initSlide" type="primary">{{$t('other.a368')}}</el-button>
                                <i class="el-icon-plus"></i>
                             </el-upload>
                       
                    </el-form-item>
                    
                </el-form>
            </div>
        </div>

        <div class="basic_info" ref="variations">
            <div class="title">{{$t('other.a1271')}}</div>
            <div class="basic_detail">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item :label="$t('other.a1273')" prop="variation" >
                       <el-radio v-model="radio" label="1">{{$t('other.a251')}}</el-radio>
                       <el-radio   v-model="radio" label="2">{{$t('other.a1272')}}</el-radio>
                    </el-form-item>
                     <el-form-item v-show=" radio == '2'"  :label="$t('other.a1366')" >
                        <div>
                            <el-input style="width:250px" type="text" v-model="addAttribute" :placeholder="$t('other.a1367')"></el-input>
                            <el-button style="margin:0 10px" type="primary" @click="addAttibuteItem()">{{$t('other.a1382')}}</el-button>
                        </div>
                        <div class="attribute" v-if="ruleForm.tiers.length > 0" v-for="(item,index) in ruleForm.tiers" :key="index">
                            <div class="fist_title_wrapper">
                                <div>
                                    <span v-show="!item.checked02" class="fist_title">{{item.name}}</span>
                                    <input v-show="item.checked02" v-model="item.name" placeholder="" />
                                    <i v-show="!item.checked02" class="el-icon-edit" @click="vkfb(item,index)"></i>
                                    <i v-show="item.checked02" class="el-icon-check" @click="confirmvkfb(item,index)"></i>
                                </div>
                                <span style="color:#409EFF;cursor: pointer" @click="delAttItem(index)">{{$t('other.a312')}}</span>
                            </div>
                            <div>
                                <span class="category_item" v-for="(firstItem,index02) in item.listItem" :key="index02">
                                   
                                    <span v-show="!firstItem.checked02">{{firstItem.name}}</span>
                                    <input class="kvnnf" v-show="firstItem.checked02" v-model="firstItem.name" placeholder="" />
                                    <i v-show="!firstItem.checked02" class="el-icon-edit" @click="onhv(firstItem,index,index02)"></i>
                                   
                                    <i v-show="firstItem.checked02" class="el-icon-check" @click="fixAttr(firstItem,index,index02)"></i>
                                    <i v-show="firstItem.checked02" class="el-icon-circle-close" @click="delAttr(index,index02)"></i>
                                </span>
                                
                            </div>
                        <div>
                                <el-input style="width:150px" size="mini" type="text" v-model="item.firstCategory" :placeholder="$t('other.a1247')"></el-input>
                                <el-button style="margin:0 10px" size="mini" @click.stop="addOtherspp(index)">{{$t('other.a1081')}}</el-button>
                        </div>
                        </div>
                    </el-form-item>


                     <el-form-item v-show=" activeName !== 'ROOT'" width="250"  :label="$t('other.a735')" prop="psku">
                        <div>
                            <el-input style="width:350px"  v-model="ruleForm.itemSku" :placeholder="$t('other.a298')"></el-input>
                            <!-- <el-button style="margin:0 10px" type="primary" @click="banding(ruleForm.itemSku,ruleForm.storeId)">{{$t('other.a1434')}}</el-button>
                            <el-button style="margin:0 10px" type="primary" @click="handleByuser(ruleForm.itemSku,ruleForm.storeId)">{{$t('other.a1435')}}</el-button>
                            <i v-show="ruleForm.groupId && radio == '1'" class="iconfont icon-gouSolid-copy"></i>
                            <span v-show="ruleForm.groupId && radio == '1'">{{$t('other.a1436')}}：{{ruleForm.itemSku}}</span> -->
                        </div>
                    </el-form-item>
                     <el-form-item :label="$t('other.a1245')" prop="variations">
                       <el-table
                            v-if="radio == '2'"
                            :data="ruleForm.variations"
                            :key="itemKey"
                            border
                            style="width: 100%">
                            <!-- <el-table-column width="80">
                                 <template slot-scope="props">
                                    <i v-show="props.$index == 0" @click="addItmes(0,props.$index)" class="iconfont icon-zengjiatianjiajiajian"></i>
                                    <i v-show="!props.$index == 0" @click="addItmes(1,props.$index)" class="iconfont icon-jianshao1"></i>
							    </template>
                            </el-table-column> -->
                            <el-table-column v-if="ruleForm.tiers.length>0" :label="ruleForm.tiers[0].name">
                                 <template slot-scope="props">
                                    <span>{{ruleForm.tiers[0].optionArray[props.row.tierIndex[0]]}}</span>
                                    
							    </template>
                            </el-table-column>
                              <el-table-column v-if="ruleForm.tiers.length>1"  :label="ruleForm.tiers[1].name">
                                 <template slot-scope="props">
                                    <span>{{ruleForm.tiers[1].optionArray[props.row.tierIndex[1]]}}</span>
                                    
							    </template>
                            </el-table-column>
                            <el-table-column
                            >
                                <template slot-scope="scope"  slot="header">
										 <span style="padding-right:25px">{{$t('other.a1275')}}</span>
										 <el-input size="mini" style="width:120px" @blur="setPrice(1)" v-model="priceValue" :placeholder="$t('other.a1248')"></el-input>
								   </template>
                                 <template slot-scope="props">
                                     <el-input v-if="!props.row.cost" @blur="getDataType(props.row.price)" v-model="props.row.price" :placeholder="$t('other.a1343')"></el-input>
                                      <el-input v-if="props.row.cost" @blur="getDataType(props.row.price)" v-model="props.row.price" :placeholder="props.row.cost"></el-input>
							     </template>
                            </el-table-column>
                            <el-table-column
                                prop="date"
                                width='200'
                                :label="$t('other.a310')">
                                <template slot-scope="scope"  slot="header">
										 <span style="padding-right:25px">{{$t('other.a310')}}</span>
										 <el-input size="mini" style="width:120px" @blur="setPrice(2)" v-model="stockValue" :placeholder="$t('other.a1248')"></el-input>
								   </template>
                                 <template slot-scope="props">
								    <el-input @blur="props.row.stock=Number(props.row.stock)" v-model="props.row.stock" :placeholder="$t('other.a1249')"></el-input>
							    </template>
                            </el-table-column>
                            <el-table-column
                                prop="date"
                                :label="$t('other.a1251')">
                                 <template slot-scope="props">
								  
                                    <el-input  v-model="props.row.variationSku" :placeholder="$t('other.a1250')"></el-input>
							    </template>
                            </el-table-column>
                             <el-table-column
                                v-if="activeName !== 'ROOT'"
                                prop="date"
                                width="300"
                                :label="$t('other.a1344')">
                                 <template slot-scope="props">
								
                                      <el-select v-model="props.row.cusCode" :placeholder="$t('other.a50')">
                                        <el-option
                                        v-for="item in props.row.options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <!-- <i v-show="props.row.cusCode && props.row.cusCode !== '无法匹配' " class="iconfont icon-gouSolid-copy"></i> -->
                                 
                                    
							    </template>
                            </el-table-column>
                             
                        </el-table>

                        <div v-if="radio == '1'" class="singSku_wrapper">
                            <div class="singSku">
                                <span>skuName：</span>
                                <el-input class="inputBox" v-model="ruleForm.itemSku" placeholder="sku"></el-input>
                            </div>
                            <div class="singSku">
                                <span>{{$t('other.a831')}}：</span>
                                <el-input class="inputBox" v-model="ruleForm.price" :placeholder="$t('other.a1252')"></el-input>
                            </div>
                            <div class="singSku">
                                <span>{{$t('other.a310')}}：</span>
                                <el-input class="inputBox" v-model="ruleForm.stock" :placeholder="$t('other.a310')"></el-input>
                            </div>

                          
                            
                            
                            
                        </div>
                    </el-form-item>
                    
                </el-form>
            </div>
        </div>

        <div class="basic_info">
            <div class="title" ref="logistic">{{$t('other.a1276')}}</div>
            <div class="basic_detail">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item :label="$t('other.a1253')" prop="weight">
                        <el-input @blur="ruleForm.weight=Number(ruleForm.weight)" style="width:250px;margin-right:15px" v-model="ruleForm.weight"></el-input>
                        <span>KG</span>
                    </el-form-item>
                     <el-form-item :label="$t('other.a1254')" prop="name">
                        <el-input @blur="ruleForm.packageLength=Number(ruleForm.packageLength)"  style="width:80px;margin-right:15px" v-model="ruleForm.packageLength" :placeholder="$t('other.a1255')"></el-input>
                        <el-input @blur="ruleForm.packageWidth=Number(ruleForm.packageWidth)" style="width:80px;margin-right:15px" v-model="ruleForm.packageWidth" :placeholder="$t('other.a1256')"></el-input>
                        <el-input @blur="ruleForm.packageHeight=Number(ruleForm.packageHeight)" style="width:80px;margin-right:15px" v-model="ruleForm.packageHeight" :placeholder="$t('other.a1257')"></el-input>
                        <span>CM</span>
                    </el-form-item>

                   

                    <el-form-item v-show=" activeName !== 'ROOT' && activeName != 'PRO'" :label="$t('other.a619')" prop="name">
                        <div>
                            <el-checkbox v-model="checkedAlllogisctic" @>{{$t('other.a1383')}}</el-checkbox>
                            <el-button style="margin:0 15px" type="primary" @click="syncLogistics()">{{$t('other.a1384')}}</el-button>
                        </div>
                        <div>
                            <el-checkbox v-model="it.enabled" v-for="(it,index12) in logisticeByshop" :key="index12">{{it.logistics_channel_name}}</el-checkbox>
                        </div>
                    </el-form-item>
                    
                </el-form>
            </div>
        </div>

         
  </div>
  <span slot="footer" class="dialog-footer">
    <!-- <el-button @click="dialogVisible = false">{{$t('other.a106')}}</el-button> -->
    <el-button v-if="activeName != 'ROOT' " type="primary" @click="publishAndsave()" >{{$t('other.a1385')}}</el-button>
                <el-button v-if="activeName == 'DXS'" style="margin-right:60px" type="primary" @click="saveItem()">{{$t('other.a1386')}}</el-button>
                <el-button v-if="(activeName != 'ROOT' ) " type="primary" @click="saveItem('ruleForm')" >{{$t('other.a1387')}}</el-button>
                <!-- <el-button v-if="(activeName == 'ROOT' && !fabuProduct) || addOthers" style="margin-right:60px" type="primary" @click="cancel()">{{$t('other.a106')}}</el-button> -->
                

                 <el-button v-if="fabuProduct" style="margin-right:10px" type="primary" @click="immediatelyPublish()">{{$t('other.a1388')}}</el-button>
    <el-button type="primary" @click="succed">{{$t('other.a106')}}</el-button>
  </span>
  
</el-dialog>
    <el-dialog :title="$t('other.a1368')" :visible.sync="dialogVisible" width="85%">
      <el-scrollbar
        wrapClass="scrollbar-wrap"
        style="height:550px"
        ref="scrollbarContainer">
        <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
          <span>{{$t('other.a1389')}}</span>
        </div>
        <div class="text item">
             <div>{{$t('other.a817')}}：{{proddata.productName}}</div>
            <div>{{$t('other.a1390')}}：{{proddata.productDescription}}</div>
            <div>{{$t('other.a1370')}}：{{proddata.productId}}</div>
            <div>{{$t('other.a1260')}}：{{proddata.productKeyWord}}</div>
            <div>{{$t('other.a1391')}}：{{proddata.productSku}}</div>
            <div>{{$t('other.a1392')}}：{{proddata.purchaseCost}}</div>
            <div>{{$t('other.a1393')}}：{{proddata.salesStatus}}</div>
            <div>{{$t('other.a1394')}}：{{proddata.productUrl==null?$t('other.a354'):proddata.productUrl}}</div>
            <div>{{$t('other.a1395')}}：{{proddata.productPrincipal}}</div>
            <div>{{$t('other.a1263')}}：{{ showsuplier(proddata.supplier)}}</div>
            <div>{{$t('other.a1264')}}：{{ showStoreName(proddata.warehouse)}}</div>
           
        </div>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
          <span>{{$t('other.a1396')}}</span>
        </div>
        <div class="text item">
          <el-table :data="productAttributesData" style="width: 100%">
            <el-table-column prop="attributeId" :label="$t('other.a1369')" width="180">
            </el-table-column>
            <el-table-column prop="attributeName" :label="$t('other.a1243')" width="180">
            </el-table-column>
            <el-table-column prop="attributeValue" :label="$t('other.a1111')" width="180">
            </el-table-column>
            <el-table-column :label="$t('other.a1244')">
          <template slot-scope="scope">
            <span>{{scope.row.attributeType==0?$t('other.a1269'):$t('other.a1270')}}</span>
          </template>
        </el-table-column>
            <el-table-column prop="productId" :label="$t('other.a1370')"> </el-table-column>
            <el-table-column :label="$t('other.a1371')">
          <template slot-scope="scope">
            <div class="order_time">
              {{$t('other.a57')}}：{{ renderTime(scope.row.createdTime) }}
            </div>
            <div class="order_time">
              {{$t('other.a1397')}}：{{ renderTime(scope.row.updateTime) }}
            </div>
          </template>
        </el-table-column>
          </el-table>
        </div>
      </el-card>
      <el-card class="box-card" shadow="hover" style="margin-top:20px">
        <div slot="header" class="clearfix">
          <span>{{$t('other.a1398')}}</span>
        </div>
        <div class="text item">
            <div>{{$t('other.a1370')}}(cm)：{{productLogisticData.productId}}</div>
            <div>{{$t('other.a1399')}}(cm)：{{productLogisticData.length}}</div>
             <div>{{$t('other.a1400')}}(cm)：{{productLogisticData.wide}}</div>
            <div>{{$t('other.a1401')}}(cm)：{{productLogisticData.height}}</div>
             
              <div>{{$t('other.a1168')}}(kg)：{{productLogisticData.weight}}</div>
              
        </div>
      </el-card>

      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
          <span>{{$t('other.a1402')}}</span>
        </div>
        <div class="text item">
      
          <el-table :data="attributeListData" style="width: 100%">
            <el-table-column prop="skuName" :label="$t('other.a218')" width="180">
            </el-table-column>
            <el-table-column prop="estimatedPurchasePrice" :label="$t('other.a1372')" width="180">
            </el-table-column>
            <el-table-column prop="inventory" :label="$t('other.a310')" width="180">
            </el-table-column>
            <el-table-column prop="productId" :label="$t('other.a1370')" width="180">
            </el-table-column>
            <el-table-column prop="skuId" label="skuId" width="180">
            </el-table-column>
            
          </el-table>
        </div>
      </el-card>
      </el-scrollbar>
      
    </el-dialog>
    <div style="margin-right: 15px">
        <div >
		    <span class="demonstration">{{$t("other.a866")}}：</span>
		    <el-date-picker
		      v-model="value9"
		      type="daterange"
			  @change="getValue()"
			  value-format="yyyy-MM-dd"
		      :start-placeholder="$t('other.a45')"
		      :end-placeholder="$t('other.a46')"
		      >
		    </el-date-picker>
		</div>
         <div>
			<div style="margin: 20px 0;display: flex;"  v-for="(item,index01) in buttonList" :key="index01">
				<div class="desc">{{item.desc}}</div>
				<span class="filterbox" >
                    <span v-for="(ttp,index) in item.value" :key="index" >
                        <span class="storeBox"  :class="{'ttpactive': activeIndex[index01] == ttp.label }" @click="handle(ttp.label,index01,index,ttp.value)"  v-show="index <= item.numType" >
                       
                            {{ttp.label}} 
                        
                        
                       
						
					</span>
                    </span>
					
				<span style="color: #409eff;cursor: pointer;" @click="editsss(item,index)" v-show="item.numType == 6">{{$t('other.a1403')}}({{$t('other.a1199')}}{{item.value.length - 6}})</span>	
                <!-- <span v-show="item.numType != 6" @click="ssitss(item,index)">收起</span> -->
				</span>
                
			</div>
            
		</div>
        {{$t('other.a1404')}}：
      <el-select v-model="value" :placeholder="$t('other.a1373')" width="50px" @change="changeVaslue">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
      <el-input
        style="width: 350px; margin-right: 5px"
        v-model="input"
        :placeholder="$t('other.a1327')"
      ></el-input>
      <el-button
        tyle="margin-right:5px"
        type="primary"
        icon="el-icon-search"
        @click="seek()"
        >{{$t('other.a27')}}</el-button
      >
    </div>
    <div style="margin-top: 20px; width: 100%" max-height="650">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column :label="$t('other.a1374')">
          <template slot-scope="scope">
            <div class="pic_box">
              <el-popover placement="top" title="" trigger="hover">
                <img
                  :src="scope.row.photoList[0]"
                  style="width: 350px; hright: 250px"
                />
                
                
                  <img
                  slot="reference"
                  :src="scope.row.photoList[0]"
                  :alt="scope.row.photoList[0]"
                  style="width: 100%"
                />
                
                
                
              </el-popover>
              <!-- <img style="width: 100%" :src="scope.row.photoList[0]" /> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('other.a1371')">
          <template slot-scope="scope">
            <div class="order_time">
              {{$t('other.a57')}}：{{ renderTime(scope.row.createdTime) }}
            </div>
            <div class="order_time">
              {{$t('other.a1397')}}：{{ renderTime(scope.row.updatedTime) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="itemSkuType" :label="$t('other.a1120')"  width="280">
          <template slot-scope="scope">
            <div class="order_time">{{$t('other.a817')}}：{{ scope.row.productName }}</div>
            <div class="order_time">{{$t('other.a1370')}}：{{ scope.row.productId }}</div>
            <!-- <div class="order_time_s">
              {{$t('other.a1390')}}：{{ scope.row.productDescription }}
            </div> -->
            <div class="order_time">
              {{$t('other.a1260')}}：{{ scope.row.productKeyWord == "" ? $t('other.a1375'): scope.row.productKeyWord}}
            </div>
            <div class="order_time">
              {{$t('other.a1392')}}：{{ scope.row.purchaseCost == 0 ? $t('other.a1375') :  scope.row.purchaseCost}}
            </div>
            <div class="order_time">
              {{$t('other.a1391')}}：{{ scope.row.productSku }}
            </div>
            <!-- <div class="order_time">
              {{$t('other.a1346')}}：{{ scope.row.productStatus }}
            </div> -->
            <div class="order_time">
              {{$t('other.a1393')}}：{{ scope.row.salesStatus }}
            </div>
            <div class="order_time">{{$t('other.a1394')}}：{{ scope.row.productUrl }}</div>
            <div class="order_time">
              {{$t('other.a1395')}}：{{ scope.row.productPrincipal }}
            </div>
            <div class="order_time">{{$t('other.a1263')}}：{{ showsuplier(scope.row.supplier) }}</div>
            <div class="order_time">{{$t('other.a1264')}}：{{ showStoreName(scope.row.warehouse) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="estimateProfit" :label="$t('other.a1258')" width="180">
        </el-table-column>
        <el-table-column prop="isQualityTest" :label="$t('other.a1259')">
          <template slot-scope="scope">
            <span>{{
              scope.row.isQualityTest == "is_quality_test" ? $t('other.a1280') : $t('other.a1281')
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="itemSkuType" :label="$t('other.a1376')">
          <template slot-scope="scope">
            <span>{{ scope.row.itemSkuType == 1 ? $t('other.a251') : $t('other.a1272') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="productStatus" :label="$t('other.a1346')">
          <template slot-scope="scope">
            <span>{{productStatus[scope.row.productStatus]}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('other.a33')" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="toedit(scope.$index, scope.row)"   style="margin:10px"
              >{{$t('other.a1405')}}</el-button
            >
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"  style="margin:10px"
              >{{$t('other.a1105')}}</el-button
            >
            <el-button
              size="mini"
              type="danger"
              style="margin:10px"
              @click="handleDelete(scope.$index, scope.row)"
              >{{$t('other.a312')}}</el-button
            >
             <el-button
              size="mini"
              type="primary"
              style="margin:10px"
              v-show="scope.row.productStatus!='AUDITED'"
              @click="addProducts(scope.$index, scope.row)"
              >{{$t('other.a1406')}}</el-button
            >
             <!-- <el-button
              size="mini"
              type="primary"
              style="margin:10px"
              v-show="scope.row.productStatus!='CREATED'"
              @click="proBack(scope.$index, scope.row)"
              >{{$t('other.a2943')}}</el-button
            > -->
            <!-- <el-button size="mini" v-show="scope.row.productStatus!='AUDITED'" @click="auditProduct(scope.$index, scope.row)"  style="margin:10px" type="warning"
              >通过审核</el-button
            >
            <el-button size="mini" v-show="scope.row.productStatus=='AUDITED'"   style="margin:10px" type="primary" @click="publishProduct(scope.$index, scope.row)"
              >{{$t('other.a285')}}</el-button
            >
            <el-button size="mini" v-show="scope.row.productStatus=='AUDITED'"   style="margin:10px" type="warning" @click="productsSta(scope.$index, scope.row)"
              >产品发布状态</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
   
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage4"
      :page-sizes="[50, 100, 150, 200]"
      :page-size="pageSize4"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
    </div>
  </div>
</template>
 
 <script>
 import utils from '../../utils/utils'
import Vue from "vue";
import api from "../../api/api";
import draggable from "vuedraggable"
import { mapState, mapMutations } from 'vuex'
import i18n from '@/i18n/i18n'
export default {
  data() {
    return {
      rules: {
        name: [
        { required: true, message: this.$t('other.a1282'), trigger: 'blur' },
        { min: 1, max: 255, message: this.$t('other.a1283'), trigger: 'blur' }
        ],
        description: [
        { required: true, message: this.$t('other.a1284'), trigger: 'blur' }
        ],
        categories: [
        { required: true, message: this.$t('other.a1285'), trigger: 'blur' }
        ],
        variation:[
        { required: true, message: this.$t('other.a1286'), trigger: 'blur' }
        ],
        weight:[
        { required: true, message: this.$t('other.a1287'), trigger: 'blur' }
        ],
        variations:[
        { required: true, message: this.$t('other.a1288'), trigger: 'blur' }
        ],
        isMandatory:[
        { required: true, message: this.$t('other.a1289'), trigger: 'blur' }
        ],
        userValue:[
        { required: true, message: this.$t('other.a1282'), trigger: 'blur' },
       
        ],
        psku:[
        { required: true, message: this.$t('other.a1290'), trigger: 'blur' },
       
        ],
       
    },
    ruleForm1:{
        categories:null
    },


     rules1: {
        categories: [
            { required: true, message: this.$t('other.a1285'), trigger: 'blur' }
        ],
       
    },
    userId:JSON.parse(localStorage.getItem('userInfo')).userId,
    itemKey:0,
    targetIndex:0,
    logisticeByshop:[],
    checkedAlllogisctic:false,
    shoidForLogistics:null,
    rangeNumber:20,
    currentPage:-1,
    imageList:'',
    indexOne:2,
    options:[],
    statusOptions:[{
        label:this.$t('other.a1291'),
        value:'NORMAL'
    },{
        label:this.$t('other.a1292'),
        value:'UNLIST'
    }],
    value:'',
    categories:'',
    targetShopId:[],
    addAttribute:'',
    tableList:[],
      dialogVisible:false,
    showCaetgory:false,
    productName:'',
    active: 0,
    cateList:[],
    priceValue:'',
    stockValue:'',
    activeName:'ROOT',
    categoryList:[],
    secondCategory:[],
    thiryCategory:[],
    fourCategory:[],
    fiveCategory:[],
    categoryIdList:[],
    firstCategorylist:[{
        checked:true,
        checked02:false,
        name:this.$t('other.a1293')
    }],
    firstCategory:'',
    attributes:[],
    
      shopOptions:[],
      
      sitelist:[{
        label:this.$t('other.a1294'),
        value:'ROOT'
    },{
            label:this.$t('other.a1295'),
            value:'DXS'
        }],
      activeName:'ROOT',
      firstScrollTop:'',//记录离开页面时滚动条的位置
      productSearchDTO :{
          endTime: "",
          pageNum:1,
          pageSize:50,
          productName: "",
          productStatus:"CREATED",
          skuName: "",
          startTime: "",
          supplier: "",
          userId:JSON.parse(localStorage.getItem('userInfo')).userId,
          wareHouse: ""
        },
      options: [{
          value: 'productName',
          label: this.$t('other.a817')
        }, {
          value: 'skuName',
          label: this.$t('other.a218')
        }],
        value: 'productName',
      total:null,
      currentPage4:1,
      pageSize4:50,
      productStatus:{
        "AUDITED":this.$t('other.a1407'),
        
        "CREATED":this.$t("other.a848")
      }, 
      dataParams:{
        endTime:"2021-09-13T01:16:14.600Z",
        productName:"123",
        skuName:"123",
        startTime:"2021-09-13T01:16:14.600Z",
        supplier: "123",
        wareHouse:"123",
    },
      attributeListData:[],//采购单sku信息封装
      productLogisticData:[],//产品物流信息
      productAttributesData: [], //产品属性信息
      proddata:[],
      dialogVisible: false,
      userId: JSON.parse(localStorage.getItem("userInfo")).userId,
      tableData: [],
      input: null,
      ruleForm: {
        attributes:[],
        productShops:[],
        categories:null,
        categoryId:0,
        modelId:null,
        name: '',
        images:[],
        drag: false,
        status:'NORMAL',
        packageHeight:'',
        description:'',
        packageLength:'',
        country:'ROOT',
     
        packageWidth:'',
        weight:'',
        hasVariation:false,
        
        variations:[{
            name:'',
            price:'',
            stock:'',
            variationSku:''
        }],
        tiers:[],
        logistics:[],
        userId:JSON.parse(localStorage.getItem('userInfo')).userId
    },
    release:false,
     counstSite:[],
    radio:''  ,
    radio2:null,
    dialogVisible:false,
    pskuItem:null,
    wareOptions:[],
    storeValue:null,
    currentPage4:1,
    tableCount:0,
    searchCuscode:null,
    searchText:'',
    tierVariations:[],
    fabuProduct:false,
    addOthers:false,
    countryOption:[],
    childrenModel:[],
    soltstatus:false,
    siteValue:'all',
    statuscode:'',
    supplierData:[],
    buttonList:[],
    activeIndex:[this.$t('other.a358'),this.$t('other.a358'),this.$t('other.a848'),this.$t('other.a358')],
    flag:false,
    value9: [],
    firstScrollTop:'',//记录离开页面时滚动条的位置
    productDTO:null,
    };
  },
  components: {
     draggable
  },
        filters:{
            capitalize(country){
                const obj={
                    'all':i18n.t('other.a1408'),
                    'TH':i18n.t('other.a1305'),
                    'PH':i18n.t('other.a1306'),
                    'ID':i18n.t('other.a1307'),
                    'MY':i18n.t('other.a1308'),
                    'VN':i18n.t('other.a1310'),
                    'DXS':i18n.t('other.a406')

                }

                return obj[country]
            },
            productStatus(country){
                const obj={
                    'UNLIST':i18n.t('other.a1292'),
                    'NOMAL':i18n.t('other.a1291'),

                }

                return obj[country]
            },
        },
  inject:['reload'],
  created() {
    // this.search();
    this.getUserSuplist();
    this.init()
  },
   
   mounted(){
    //    window.addEventListener('scroll', this.menu)
    //     setTimeout(() => {
    //   this.getBtn();  
      
    // }, 1000);
      
      
    
  },
    activated() {
    this.search();
    },//在vue对象存活的情况下，进入当前存在activated()函数的页面时，一进入页面就触发
  computed: {//这一部分直接拿过来用的
    ...mapState({
        ModelData: state => state.common.ModelData
       
    }),
    dateInfo(){
				let list=JSON.parse(JSON.stringify(this.value9))
				list[1]=utils.CurdateAddoneday(list[1])
				return list
			},
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },

    list(){
        let arr=[]
        for(let i=0;i<9;i++){
            arr.push('')
        }

        return arr 
    }

  

   
  },
  watch:{
    flag(){
        if(this.flag == true){
            this.getBtn();  
        }
    },
    input(){
      if (!this.input) {
        this.productSearchDTO.productName ='';
        this.productSearchDTO.skuName = '';
        this.productSearchDTO.supplier = '';
        this.productSearchDTO.wareHouse = '';
        this.search();
      }
    },
    categories(){
          this.ruleForm.categories=this.categories
      },
     dialogVisible(){
         if(!this.dialogVisible){
             this.pskuItem=null
             this.radio2=null
         }
     },
     searchCuscode(){
         if(!this.searchCuscode){
             this.getDataList.cusCode=null
             this.getStoreItem()
         }
     },

     targetShopId(){
         this.logisticeByshop=[]
         let params={
             categoryId:this.categoryIdList[this.categoryIdList.length-1],
             shopId:this.targetShopId[0]
         }
         console.log('params',params)
         this.getLoagistics(params)
        //  this.targetShopId.forEach(k => {
        //      this.getLoagistics(k)
        //  })
      
     },
     
     checkedAlllogisctic(){
         if(this.checkedAlllogisctic){
             this.logisticeByshop.forEach(k => {
                 k.enabled=true
             })
         }else{
             this.logisticeByshop.forEach(k => {
                 k.enabled=false
             })
         }
     },

     searchText(){
            console.log('8888',this.searchText,this.targetIndex)
            if(this.searchText){
                this.attributes[this.targetIndex].unit=null
                this.attributes[this.targetIndex].options=this.attributes[this.targetIndex].optionsCopy
                this.attributes[this.targetIndex].options=this.attributes[this.targetIndex].options.filter(item => {
                    if(item.includes(this.searchText)){
                        return item
                    }
                })

            }else{
                p.options=p.optionsCopy
            }


            // this.attributes.forEach(p => {
            //     if(this.searchText){
            //         p.unit=null
            //         p.options=p.optionsCopy
            //         p.options=p.options.filter(item => {
            //             if(item.includes(this.searchText)){
            //                 return item
            //             }
            //         })
                    
            //     }else{
            //         p.options=p.optionsCopy
            //     }
            //     p.options= p.options ? p.options : p.p.optionsCopy
            // })

            console.log('attributes',this.attributes)
        }
  },
  directives:{
    clickOutSide:{
        bind:function(el, binding , vnode){
            function documentHandler(e){
                if(el.contains(e.target)){
                return false
                }

                if(binding.expression){
                    binding.value(e)
                }
            }
            el._vueClickOutside_ =documentHandler
            document.addEventListener('click',documentHandler)
        },

        unbind:function (el,binding) {
            document.removeEventListener('click',el._vueClickOutside_)
        }

    },
    el_selectLoadmore:{
        bind(el,binding){
            let self=this
            const SELECTWRAP_DOM =el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
           
            SELECTWRAP_DOM.addEventListener('scroll', function () {
                const condition = this.scrollHeight - this.scrollTop-20 <= this.clientHeight
                if (condition) binding.value()
            })
        }
    }
},
  methods: {
     menu() {
        //731
        let windowH = `${document.documentElement.clientHeight}`;
        //浏览器总高 6058
        let top=document.getElementById('app').scrollHeight
        //
        this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
        let num=this.scroll + Number(windowH)
        this.firstScrollTop = this.scroll
        console.log(this.scroll)
        // if(num == top){
        //   alert('滚到底了')
        // }
        
        // console.log('top',top)
        // console.log('windowH',windowH)
        // console.log(this.scroll)
    },
      getValue(){
      if(this.value9 == null){
        this.productSearchDTO.endTime=''
        this.productSearchDTO.startTime=''
        this.search();
      }else{
        console.log(this.dateInfo)
				this.productSearchDTO.endTime=this.dateInfo[1]
				this.productSearchDTO.startTime=this.dateInfo[0]
				this.search();
      }
				
				
				
            },
            editsss(item,index){
                item.numType = item.value.length
                Vue.set(this.buttonList,index,item)
                // console.log(this.buttonList)
                //     console.log(item)
            },
            ssitss(item,index){
                item.numType = 6
                Vue.set(this.buttonList,index,item)
            },
      handle(key,index,indexone,value){
              console.log(key,index,indexone,value)
              this.$set(this.activeIndex,index,key)
        if(index == 0){
          if(value == 'all'){
            this.productSearchDTO.wareHouse = "";
            this.search();
          }else{
            this.productSearchDTO.wareHouse = value
          this.search();
          }
          

        }else if(index == 1){
            if(value == 'all'){
            this.productSearchDTO.supplier = "";
            this.search();
          }else{
            this.productSearchDTO.supplier = value
          this.search();
          }
        }else if(index == 2){
            if(value == 'all'){
            this.productSearchDTO.productStatus = "";
            this.search();
          }else{
            this.productSearchDTO.productStatus = value
          this.search();
          }
        }
      },
      getBtn(){
        
				this.buttonList=[{
					id:0,
					desc:this.$t('other.a1409'),
					value:utils.getStore()
				},{
					id:2,
					desc:this.$t('other.a1410'),
					value:this.supplierData
                }
				]
				
				this.buttonList.forEach(p => {
					p.value.unshift({
						label:this.$t('other.a358'),
						value:'all'
                    })
                    if(p.value.length > 6){
                        p.numType = 6
                    }else{
                        p.numType = p.value.length
                    }
                    
				})
                
				
				
				console.log('btn',this.buttonList)
			},
    ...mapMutations("common", [
                "SET_REGISTOR_FALSE",
                'SWITCH_LANG',
            ]),
    getUserSuplist() {
      api
        .getsuplist({
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
          if (res.code == "ok") {
              let arrnew = res.productSuppliers.map((item, index) => {
                    return Object.assign(
                      {},
                      {
                        value : item.id,
                        label : item.supplier
                      }
                    );
                  });
              console.log(arrnew)
            //   this.groupsData = arrnew;
            this.supplierData = arrnew;
            this.flag =true
            console.log(this.supplierData)
          } else {
            this.$message.warning(res.msg);
          }
        });
    }, //获取用户的供应商
    showsuplier(id){
        let stores = this.supplierData
        let ttp=null
		if(stores){
			stores.forEach(p => {
				if(p.value == id){
					ttp=p.label
				}
			})
		}

		return ttp ? ttp : this.$t("other.a354")
    },
     showStoreName(id){
		let stores=JSON.parse(localStorage.getItem('userInfo')).stores
		let ttp=null
		if(stores){
			stores.forEach(p => {
				if(p.storeId == id){
					ttp=p.storeName
				}
			})
		}

		return ttp ? ttp : this.$t("other.a354")
	},
    setPrice(num){
       console.log(this.ruleForm)
       if(num == 1){
              this.ruleForm.variations.forEach(p => {
                    p.price=this.priceValue
                })
       }else if(num == 2){
           this.ruleForm.variations.forEach(p => {
                    p.stock=this.stockValue
                })
       }
    
       
    },
       group(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while(index < array.length) {
          newArray.push(array.slice(index, index += subGroupLength));
      }
      return newArray;
  },

    addOtherspp(index){
      
        this.ruleForm.tiers[index].listItem.push({
            name:this.ruleForm.tiers[index].firstCategory,
            checked02:false
        })
        this.ruleForm.tiers[index].optionArray.push(
            this.ruleForm.tiers[index].firstCategory
        )
        this.$set(this.ruleForm.tiers,index,this.ruleForm.tiers[index])  
        console.log(this.ruleForm.tiers,index)
        this.ruleForm.tiers[index].firstCategory=''


        if(index == 0){
            console.log(this.ruleForm)
            console.log(index)
            let list=[]
            if(this.ruleForm.tiers.length > 1) {
                this.ruleForm.tiers[1].optionArray.forEach((i,index) => {
                    this.ruleForm.variations.push({
                        cusCode:null,
                        tierIndex:[this.ruleForm.tiers[0].optionArray.length-1,index],
                        variationSku:this.ruleForm.tiers[0].optionArray[this.ruleForm.tiers[0].optionArray.length-1]+','+this.ruleForm.tiers[1].optionArray[index],
                        stock:'',
                        price:''
                    })
                })

                 console.log('list',list)
            }else{
                 this.ruleForm.variations.push({
                        cusCode:null,
                        tierIndex:[this.ruleForm.tiers[0].optionArray.length-1],
                        variationSku:this.ruleForm.tiers[0].optionArray[this.ruleForm.tiers[0].optionArray.length-1],
                        stock:'',
                        price:''
                    })
            }

           
           
        }

        if(index == 1){
            console.log(this.ruleForm)
            
            let list1=[]
            
            this.ruleForm.tiers[0].optionArray.forEach((p,index) => {
                let obj={
                    usCode:null,
                    price:'',
                    stock:'',
                    tierIndex:[index,this.ruleForm.tiers[1].optionArray.length-1],
                    variationSku:this.ruleForm.tiers[0].optionArray[index]+','+this.ruleForm.tiers[1].optionArray[this.ruleForm.tiers[1].optionArray.length-1]
                }
                list1.push(obj)
            })
            let count=this.ruleForm.tiers[1].optionArray.length-1
            let ttp=this.ruleForm.variations.length+count

            for(let i =count,j=0 ;i<ttp;i+=count,j++){
                
                console.log(i)
                this.ruleForm.variations.splice(i,0,list1[j])
                i++
            }
            console.log(this.ruleForm.variations)
            console.log('list1',list1)  
        }
    },
    
    delAttItem(index){
        this.$confirm(this.$t('other.a1311'),this.$t("other.a142"),{
            confirmButtonText:this.$t('other.a145'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
        }).then(() => {
            this.ruleForm.tiers.splice(index,1)
        })
    },

    addAttibuteItem(){
        console.log(this.addAttribute)
        if(this.ruleForm.tiers.length == 2){
            this.$message.warning(this.$t('other.a1312'))
            return
        }else if(!this.addAttribute){
           
            return
        }
        this.ruleForm.tiers.push({
            name:this.addAttribute,
            listItem:[],
            optionArray:[],
            images:[],

        })

        this.addAttribute=''
    },

    // publishProduct(){
    //     this.$confirm(this.$t('other.a1313'),this.$t("other.a142"),{
    //         confirmButtonText:this.$t('other.a145'),
    //         cancelButtonText: this.$t('other.a146'),
    //         type: 'warning'
    //     }).then(() => {
    //         console.log(this.ruleForm)
    //         let obj=this.ruleForm.children.find(p => p.country === this.activeName)
    //         console.log(obj)
    //         api
    //         .publishProducts({
    //             productId:obj.productId
    //         })
    //         .then(res => {
    //             if(res.code === 200){
    //                 this.$message.success(this.$t('other.a1314'))
    //             }
    //         })
    //     })
    // },
     immediatelyPublish(){
        console.log(this.ruleForm)
         if(this.ruleForm.country === 'ROOT'){
            this.$message.warning(this.$t('other.a1297'))
            return
        }
        if(this.activeName !== 'DXS'){
            if(this.ruleForm.productShops.length == 0){
                this.$refs.shopAndCategory.scrollIntoView()
                this.$message.warning(this.$t('other.a1298'))
                return
            }
        }
        if(!this.categories && this.activeName !== 'DXS'){
            this.$refs.shopAndCategory.scrollIntoView()
            this.$message.warning(this.$t('other.a1285'))
            return
        }

        if(!this.ruleForm.attributes.length && this.activeName !== 'DXS'){
            this.$refs.shopAndCategory.scrollIntoView()
            this.$message.warning(this.$t('other.a1299'))
            return
        }

        let list=[]
        this.ruleForm.variations.forEach(p => {
            if(!p.price){
                list.push(p)
            }
        })
        if(list.length) {
            this.$refs.variations.scrollIntoView()
            this.$message.warning(this.$t('other.a1300'))
            return
        }

        if(!this.ruleForm.weight  && this.activeName !== 'DXS'){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1301'))
            return
        }
        if(!this.ruleForm.packageHeight || !this.ruleForm.packageLength  || !this.ruleForm.packageWidth){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1301'))
            return
        }
        let list2=[]
        this.logisticeByshop.forEach(p => {
            if(p.enabled){
                list2.push(p)
            }
        })

        if(!list2.length && this.activeName !== 'DXS'){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1302'))
            return
        }
        console.log(1417,this.ruleForm)
       
       
        if(this.logisticeByshop.length){//如果用户选择了商店，自动帮助用户填充物流的默认信息
            this.ruleForm.logistics=this.logisticeByshop.filter(k => {
                k.logisticId=k.logistics_channel_id
                if(k.enabled){
                    return k
                }
            })
        }
        this.ruleForm.modelId=this.$route.query.id
        let imageList=[]
        this.ruleForm.images.forEach((p,index) => {
            p.positions=index
            if(p.image){
                imageList.push(p)
            }
        })

        this.ruleForm.images=imageList
        api
        .updataProduct(this.ruleForm)
        .then(res => {
            if(res.code === 200){
                console.log('新增模版',res.data)
                let newModel=res.data

                if(this.activeName == 'DXS'){
                    api
                    .publishProductToDXS({
                        productId:res.data.productId,
                        userId:this.userId,
                        online:true
                        
                    })
                    .then(res => {
                        if(res.code === 200){
                        this.$message.success(this.$t('other.a1303'))
                        }else{
                            this.$message.warning(res.msg)
                        }
                    })

                    return
                }
                 api
                .publishProducts({
                    productId:res.data.productId,
                    userId:this.userId
                })
                .then(res => {
                    if(res.code === 200){
                            res.data.forEach(p => {
                            if(p.msg.indexOf('上架成功') > -1) {
                                this.$message.success(p.msg)
                            
                            }else{
                                this.$message.success(p.msg)
                                // api
                                // .deleteChildrenMoadel(newModel)
                                // .then(res => {
                                //     if(res.code === 200){
                                        
                                //     }
                                // })
                            }
                            
                        })
                    }else{
                        this.$message.warning(res.msg)
                    }
                })    
            }else{
                this.$message.warning(res.msg)
                
            }
        })
    },
    loadMore(){
        return () => this.rangeNumber += 5
    },
    syncLogistics(){
        this.logisticeByshop=[]
        api
        .getShopLogisticsAndAttribute({shopId:this.targetShopId[0],categoryId:this.categoryIdList[this.categoryIdList.length-1]})
        .then(res => {
            if(res.code === 200) {
                console.log('物流和类目',res.data)
                let logistics=res.data.logistics
                let attributes=res.data.attributes
                logistics.forEach(k => {
                    k.checked=false 
                })

                this.logisticeByshop.push(...logistics)
                let obj1 = {};
                let res1 = [];
                this.logisticeByshop.forEach(k => {
                    if(!obj1[k.logisticId]){
                        res1.push(k)
                        obj1[k.logisticId]=true
                    }
                })

                this.logisticeByshop=res1
                console.log('logisticeByshop',this.logisticeByshop)
                this.$message.success(this.$t('other.a1304'))
                
            }
        })
        
    },
    saveItem(){
        delete this.ruleForm.radio  
        let imageList=[]
        this.ruleForm.images.forEach((p,index) => {
            p.positions=index
            if(p.image){
                imageList.push(p)
            }
        })

        this.ruleForm.images=imageList

        // if(this.$route.query.addOthers){//母模版下新增商品
           this.ruleForm.modelId=this.ruleForm.productId
           this.ruleForm.productId=null
           if(this.activeName === 'DXS'){
               this.ruleForm.status='DXS'
           }else{

               this.ruleForm.country=this.activeName
           }
        // }

        if(this.$route.query.productId){//保存商品到用户选择的站点
            this.ruleForm.modelId=Number(this.$route.query.productId)
            if(this.activeName === 'DXS'){
               this.ruleForm.status='DXS'
           }
        }

        if(this.$route.query.id){//保存商品到用户选择的站点
            this.ruleForm.modelId=Number(this.$route.query.id)
        }

        if(this.logisticeByshop.length){//如果用户选择了商店，自动帮助用户填充物流的默认信息
            this.ruleForm.logistics=this.logisticeByshop.filter(k => {

                if(k.enabled){
                    return {
                        enabled:k.enabled,
                        logisticId:k.logistics_channel_id,
                    }
                }
            })
        }

        
       console.log(this.ruleForm)
       

        api
        .updataProduct(this.ruleForm)
        .then(res => {
            if(res.code === 200){
                console.log('新增模版',res.data)
                this.$message.success(this.$t('other.a1411'))
                localStorage.removeItem('modelId')
                // setTimeout(() => {
                //     this.$router.push('/templateManagement')
                // },500)
                this.release = false
                
            }else{
                this.$message.warning(res.msg)
            }
        })
    },
     publishAndsave(){//保存并立即发布
        console.log(this.sitelist)
        if(this.activeName == 'ROOT'){
            this.$message.warning(this.$t('other.a1316'))
            return
        }

    
        if(this.ruleForm.productShops.length == 0){
            this.$refs.shopAndCategory.scrollIntoView()
            this.$message.warning(this.$t('other.a1298'))
            return
        }

        if(!this.categories){
            this.$refs.shopAndCategory.scrollIntoView()
            this.$message.warning(this.$t('other.a1285'))
            return
        }

        if(!this.ruleForm.attributes.length ){
            this.$refs.shopAndCategory.scrollIntoView()
            this.$message.warning(this.$t('other.a1299'))
            return
        }

        let list=[]
        this.ruleForm.variations.forEach(p => {
            if(!p.price ){
                list.push(p)
            }
        })
        if(list.length) {
            this.$refs.variations.scrollIntoView()
            this.$message.warning(this.$t('other.a1317'))
            return
        }

        if(!this.ruleForm.weight ){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1301'))
            return
        }

        if(!this.ruleForm.packageHeight || !this.ruleForm.packageLength  || !this.ruleForm.packageWidth){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1301'))
            return
        }
        let list2=[]
        console.log('logisticeByshop',this.logisticeByshop)
        this.logisticeByshop.forEach(p => {
            if(p.enabled){
                list2.push({

                })
            }
        })
        if(!list2.length){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1302'))
            return
        }

       
        if(this.logisticeByshop.length){//如果用户选择了商店，自动帮助用户填充物流的默认信息
            this.ruleForm.logistics=[]
            this.logisticeByshop.forEach(k => {
                if(k.enabled){
                    this.ruleForm.logistics.push({
                        enabled:k.enabled,
                        logisticId:k.logistics_channel_id,
                    })
                }
            })
        }
        this.ruleForm.modelId=this.$route.query.id
        let imageList=[]
        this.ruleForm.images.forEach((p,index) => {
            p.positions=index
            if(p.image){
                imageList.push(p)
            }
        })

        this.ruleForm.images=imageList

        this.ruleForm.modelId=this.$route.query.idModel
        this.ruleForm.productId=null

        console.log(1417,this.ruleForm)

        api
        .updataProduct(this.ruleForm)
        .then(res => {
            if(res.code === 200){
                console.log('新增模版',res.data)
                 api
                .publishProducts({
                    productId:res.data.productId,
                    userId:this.userId
                })
                .then(res => {
                    if(res.code === 200){
                            res.data.forEach(p => {
                            this.$message.success(p.msg)
                            if(p.msg.indexOf('上架成功') > -1) {
                              
                              setTimeout(() => {
                                   location.replace('/templateManagement')
                              },500)
                            }else{
                                
                            }
                            
                        })
                    }else{
                        this.$message.warning(res.msg)
                    }
                })    
            }else{
                this.$message.warning(res.msg)
                
            }
        })

    },
     getLoagistics(params){
        api
        .getShopLogisticsAndAttribute(params)
        .then(res => {
            if(res.code === 200) {
                console.log('物流和类目',res.data)
                let logistics=res.data.logistics
                let attributes=res.data.attributes

               
                attributes.forEach(p => {
                    p.userValue=''
                })
                console.log('rules',this.rules)
                attributes.forEach(p => {
                    p.optionsCopy=p.options
                })
                attributes.sort((a,b) => {
                    return a.attribute_name.charCodeAt(0)-b.attribute_name.charCodeAt(0)
                })
                this.attributes=attributes
                console.log('attributes',this.attributes)




                logistics.forEach(k => {
                    k.checked=false 
                })

                this.logisticeByshop.push(...logistics)
                let obj1 = {};
                let res1 = [];
                this.logisticeByshop.forEach(k => {
                    if(!obj1[k.logisticId]){
                        res1.push(k)
                        obj1[k.logisticId]=true
                    }
                })

                this.logisticeByshop=res1
                console.log('logisticeByshop',this.logisticeByshop)
               
           
               
            }else{
                this.$message.warning(res.msg)
            }
        })

        
    },
       vkfb(item,index){
         console.log(item)
         item.checked02=true
         this.$set(this.ruleForm.tiers,index,item)  
    },

    onhv(item,index,index02){
        item.checked02=true
        
        this.$set(this.ruleForm.tiers[index],index02,item)  
    },

    fixAttr(item,index,index02){
        console.log(item,index,index02)
        item.checked02=false

        this.ruleForm.tiers[index].optionArray[index02]=item.name
        this.ruleForm.tiers[index].listItem[index02].name=item.name
        this.ruleForm.tiers[index].listItem[index02].checked02=false
        this.$set(this.ruleForm.tiers,index,this.ruleForm.tiers[index])  

         console.log(this.ruleForm.tiers)
        this.itemKey=Math.random()
    },

    confirmvkfb(item,index){
         console.log(item,index)
         item.checked02=false
         this.$set(this.ruleForm.tiers,index,item)  
    },
    init(){
        this.value9=[utils.getRecentSevenDay(-30),utils.getRecentSevenDay(1)]
				this.productSearchDTO.endTime=this.dateInfo[1]
				this.productSearchDTO.startTime=this.dateInfo[0]
				this.search();
        for(let i=0;i<9;i++){
            this.ruleForm.images.push({
                image:'',
                positions:i
            })
        }
        this.countryOption=utils.getCountryOption()
       

         if(this.$route.query.addOthers){//新增商品
          this.ModelData.status=null
           this.addOthers=true
           this.ModelData.condition="NEW"
            this.ModelData.tiers.forEach(k => {
                k.checked02=false
                k.listItem=k.optionArray.map(k => {
                    return {
                        name:k,
                        checked02:false
                    }
                })
            })
           console.log('774852',this.ModelData)
           this.scrapedDataByshopee(this.ModelData)
           
        }

        if(this.$route.query.productId){//编辑
         this.addOthers=true
         this.ModelData.tiers.forEach(k => {
                k.checked02=false
                k.listItem=k.optionArray.map(k => {
                    return {
                        name:k,
                        checked02:false
                    }
                })
            })
            console.log(this.$route.query.productId)
           
            console.log('model',this.ModelData)


            const code={
                'TH':this.$t('other.a1305'),
                'PH':this.$t('other.a1306'),
                'ID':this.$t('other.a1307'),
                'MY':this.$t('other.a1308'),
                'TW':this.$t('other.a1309'),
                'VN':this.$t('other.a1310'),
            }

            this.ruleForm=this.ModelData
            if(this.ModelData.variations.length > 0){//多规格
                this.radio='2'
            }else{//单品
                this.radio='1'
            }
            console.log('ModelData',this.ruleForm)

            this.active=2
            this.sitelist=[{
                label:this.$t('other.a1294'),
                value:'ROOT'
            },{
                label:this.$t('other.a1295'),
                value:'DXS'
            }]
            this.sitelist.push({
                label:code[this.ModelData.country 
                ] + this.ModelData.productId,
                value:this.ModelData.country,
            })
            this.counstSite=[{
                country:'ROOT',
                value:this.ModelData
            }]
            this.counstSite.push(this.ModelData)
             console.log('ModelData',this.ModelData)
             console.log('counstSite',this.counstSite)

             
           
        }else{
            this.getShop()
        }

        if(this.$route.query.itemId){//线上导入
              let itemId=this.$route.query.itemId
                if(itemId !== undefined){
                    api
                    .getItemAttribute({itemId})
                    .then(res => {
                    if(res.code === 200) {
                        console.log('itemId',res.data)
                        this.ruleForm.categoryId=res.data.item.categoryId
                        this.ruleForm.name=res.data.item.name
                        this.ruleForm.packageHeight=res.data.item.packageHeight
                        this.ruleForm.packageLength=res.data.item.packageLength
                        this.ruleForm.packageWidth=res.data.item.packageWidth
                        this.ruleForm.itemId=res.data.item.itemId
                        this.ruleForm.hasVariation=res.data.item.hasVariation
                        this.ruleForm.cusCode=res.data.item.cusCode
                        this.ruleForm.shopee=res.data.item.shopee
                        this.ruleForm.sales=res.data.item.sales
                        this.ruleForm.condition='NEW'
                        this.ruleForm.itemSku=res.data.item.itemSku
                        this.ruleForm.weight=res.data.item.weight
                        this.ruleForm.description=res.data.item.description
                        res.data.images.forEach(p => {
                            this.ruleForm.images[p.positions].image=p.image
                        })
                        this.ruleForm.variations=[]

                        if(res.data.item.hasVariation && res.data.item.variations !== null){//如果有variations,多规格
                            this.radio="2"
                            this.ruleForm.hasVariation=true
                                res.data.item.variations.forEach(p =>{
                                    this.ruleForm.variations.push({
                                        name:p.name,
                                        price:p.price,
                                        stock:p.stock,
                                        variationSku:p.variationSku
                                    })
                            })
                        }else{//单品
                            this.radio="1"
                            this.ruleForm.hasVariation=false
                            this.ruleForm.stock=res.data.item.stock,
                            this.ruleForm.price=res.data.item.price,
                            this.ruleForm.itemSku=res.data.item.itemSku
                     
                        }
                        this.ruleForm.logistics=res.data.logistics
                        console.log('tt',this.ruleForm)
                    
                    }
                })
                }
       
        }

        // 分销仓或联盟仓发布商品
        if(this.$route.query.id){
            this.fabuProduct=true
            api
            .getProductByproductId({
                productId:this.$route.query.id
            })
            .then(res => {
                if(res.code === 200){
                    let storeItems=JSON.parse(localStorage.getItem('storeItems'))
                    if(storeItems){
                        res.data.variations.forEach(p => {
                            p.options=storeItems
                        })
                    }
                    console.log(res.data)
                    res.data.tiers.forEach(k => {
                        k.checked02=false
                        k.listItem=k.optionArray.map(k => {
                            return {
                                name:k,
                                checked02:false
                            }
                        })
                    })
                    res.data.userId=this.userId
                    res.data.productShops=[]
                    res.data.country="ROOT"
                    res.data.productId=null
                    res.data.items=[]
                    res.data.variations.forEach(p => {
                        p.cost=this.$t('other.a1323')+ p.price +this.$t('other.a1324')
                        p.price=null
                        p.cusCode=p.options.find(item => item.label == p.variationSku).value
                    })
                    console.log(res.data)
                    this.ruleForm=res.data
                    if(res.data.variations.length > 0 ){//如果有variations,多规格
                        this.radio="2"
                        
                    }else{//单品
                        this.radio="1"
                    }
                }
            })
        }

      
    },
    pushAttribute(){
        console.log(this.attributes,this.rangeNumber)
        let list=this.attributes.map(p => {

            let ttp=p.unit ? p.unit : ''
            return {
                attributeId:p.attribute_id,
                attributeName:p.attribute_name,
                attributeValue:p.userValue + ttp,
                isMandatory:p.is_mandatory

            }
        })
        

        this.ruleForm.attributes=list
        console.log(this.ruleForm)
    },
    cateGory(item,index){
        console.log(item)
        if(index == 1){
           this.secondCategory=item.childrens
           this.thiryCategory=[]
           this.cateList[index-1]=item.categoryName
           this.categoryIdList[index-1]=item.categoryId
           this.cateList.splice(index,1)
           this.categoryIdList.splice(index,1)
           
        }else if(index == 2){
            this.thiryCategory=item.childrens
            this.cateList[index-1]=item.categoryName
            this.categoryIdList[index-1]=item.categoryId
            this.cateList.splice(index,1)
            this.categoryIdList.splice(index,1)
        }else if(index == 3){
            this.fourCategory=item.childrens
            this.cateList[index-1]=item.categoryName
            this.categoryIdList[index-1]=item.categoryId
            this.categoryIdList.splice(index,1)
        }else if(index == 4){
            this.fiveCategory=item.childrens
            this.cateList[index-1]=item.categoryName
            this.categoryIdList[index-1]=item.categoryId
            this.categoryIdList.splice(index,1)
        }else if(index == 5){
            this.cateList[index-1]=item.categoryName
            this.categoryIdList[index-1]=item.categoryId
            this.categoryIdList.splice(index,1)
        }


        this.categories=this.cateList.join(' / ')
        if(item.childrens == null){
            this.showCaetgory=false
            this.thiryCategory=[]
            this.fourCategory=[]
            this.secondCategory=[]
            this.fiveCategory=[]
            // this.getAttributesData()
            this.ruleForm.categoryId=this.categoryIdList[this.categoryIdList.length-1]    

        }

        this.logisticeByshop=[]
         let params={
             categoryId:this.categoryIdList[this.categoryIdList.length-1],
             shopId:this.targetShopId[0]
         }
         console.log('params',params)
         this.getLoagistics(params)

        console.log(this.ruleForm)
        console.log('categoryIdList',this.categoryIdList)
        console.log(this.cateList)
    },
    handlePictureSuccess(response, file, fileList){
        console.log('file',file)
    },
    handleUploadHttpRequest(params){
        console.log(params)
        const _file=params.file
        const isLt2M=_file.size/1024/1024 < 2

        let formData=new FormData()
        formData.append('file',_file)

        if(!isLt2M){
            this.$message.error(this.$t("other.a332"));
            return false;
        }

        api
        .uploadImg(formData)
        .then(res => {
            if(res.code === 200){
                console.log(res.data)
                this.imageList=res.data
                this.$set(this.ruleForm.images,this.currentPage,{
                    image:res.data,
                    positions:this.currentPage

                })
            }else{
                this.$message.warning(res.msg)
            }
        })
    },
    showDelBtn(index){
        console.log(index)
        this.currentPage=index
        var e = document.createEvent("MouseEvents");
        e.initEvent("click", true, true);
        document.getElementById("initSlide").dispatchEvent(e);

    },
     deleteImg(index){
        //  this.$set(this.ruleForm.images,index,'')
         this.ruleForm.images[index].image=""
    },
    handleClose(){
        this.showCaetgory=false
    },
    getCategory(){
        console.log(this.activeName)
        this.shopOptions=[]
        this.targetShopId=[]
        let shoplist=JSON.parse(localStorage.getItem('userInfo')).shopeeShops
        shoplist.forEach(p => {
            if(p.country === this.activeName){
                this.shopOptions.push({
                    label:p.shopName,
                    value:p.shopId
                })
            }
        })

        console.log('shopOptions',this.shopOptions)

        let itemObj=this.counstSite.find(item => item.country == this.activeName)
        console.log(itemObj)
        if(itemObj !== undefined){
            this.ruleForm=itemObj
            if(this.ruleForm.variations.length > 0){
                this.ruleForm.radio='2'
               
            }else{
                this.ruleForm.radio='1'
               
            }
            this.targetShopId=this.ruleForm.productShops.map(p => {
                return p.shopId
            })

            console.log('targetShopId',this.targetShopId)
        }
        let num=9-this.ruleForm.images.length
        for(let i=0;i<num;i++){
            this.ruleForm.images.push({
                image:'',
                positions:this.ruleForm.images.length+i
            })
        }



        console.log('777',this.ruleForm)
          
        

        api
        .getCategoryByCountry({
            country:this.activeName,
        })
        .then(res => {
            if(res.code === 200){
                console.log('国家获取类目',res.data)
                let originListCopy=JSON.parse(JSON.stringify(res.data)) 
                this.categoryList=res.data
                if(this.ruleForm.categoryId){
                    console.log(this.ruleForm.categoryId)
                    this.ruleForm.country=this.activeName
                    let id=this.ruleForm.categoryId
                    let list=[]
                    this.categoryIdList=[]

                    originListCopy.forEach(p => {
                        p.childrens.forEach(k => {
                            if(k.categoryId === id){
                                list.push(p.categoryName)
                                list.push(k.categoryName)
                                this.categoryIdList.push(p.categoryId)
                                this.categoryIdList.push(k.categoryId)
                            }else{
                                if(k.childrens !== null){
                                     k.childrens.forEach(i => {
                                    if(i.categoryId === id){
                                         list.push(p.categoryName)
                                         list.push(k.categoryName)
                                         list.push(i.categoryName)
                                         this.categoryIdList.push(p.categoryId)
                                         this.categoryIdList.push(k.categoryId)
                                         this.categoryIdList.push(i.categoryId)
                                    }
                                })
                                }
                               
                            }
                        })
                    })
                    console.log('list',list)
                    this.categories=list.join(' / ')

                    console.log(this.categoryIdList)
                    // this.getAttributesData()
                    
                    
                    
                }
              
               
            }else{
                this.$message.warning(res.msg)
            }
        })
    },
    getShopId(){
        console.log(this.targetShopId)

        this.ruleForm.productShops= this.targetShopId.map(p => {
            return {
                shopId:p
            }
        })
    },
    
    getShop(){
        const country={
            'TH':this.$t('other.a1305'),
            'PH':this.$t('other.a1306'),
            'ID':this.$t('other.a1307'),
            'MY':this.$t('other.a1308'),
            'TW':this.$t('other.a1309'),
            'VN':this.$t('other.a1310'),
          
        }
        let arr=JSON.parse(localStorage.getItem('userInfo')).shopeeShops
        let arr2=[]
        arr.forEach(p => {
            arr2.push(p.country)
       
        })

        arr2=[...new Set(arr2)]

        arr2.forEach(p => {
            this.sitelist.push({
                label:country[p],
                value:p
            })

        })

        console.log(this.sitelist)
       
        
        
    },
    succed(){
      this.release = false
      console.log(this.ruleForm)
      // console.log(this.ruleForm)
    },
    getDataType(price){
        let ttp=null
        if(price == '' || price == null || price == undefined){
            ttp=''
        }else{
            ttp=Number(price)
        }

        return ttp
    },
     delAttr(index,index02){
        console.log(index,index02)
        console.log(this.ruleForm)
         this.ruleForm.tiers[index].listItem.splice(index02,1)
        this.ruleForm.tiers[index].optionArray.splice(index02,1)
        this.$set(this.ruleForm.tiers,index,this.ruleForm.tiers[index])

        if(index === 0){//如果用户删除的第一级的属性
            let list1=[]
            let list2=[]
            this.ruleForm.variations.forEach((p,index) => {
                if(p.tierIndex[0] >= index02) {
                    if(p.tierIndex[0] !== index02){
                        p.tierIndex[0]-=1
                        list1.push(p)
                    }
                }else{
                    list2.push(p)
                }
            })

            this.ruleForm.variations=[...list2,...list1]
         
           console.log('list1',list1)
           console.log('list2',list2)

        }

        if(index === 1) {
           let num=0
           let list2=[]
           let list=this.group(this.ruleForm.variations,this.ruleForm.tiers[1].optionArray.length+1)

            list.forEach(p => {
                p.splice(index02,1)
            })

            list.forEach((i,) => {
                i.forEach((j,index) => {
                    j.tierIndex[1]=index
                    list2.push(j)
                })

                
            })
            this.ruleForm.variations=list2
            console.log('list2',list2)
           
            console.log('list',list)
        }

       
        
      
    },
    getProductsta(code){
        api
        .getProductByproductId({
          productId  : code,
          
        })
        .then((res) => {
          console.log(res.data);
          if (res.code == 200) {
              let arr = []
              arr.push(res.data)
              let site=[]
                        // res.data.models.forEach(p => {
                        //     p.checked01=false
                        //     p.products.forEach(k => {
                        //         k.checked02=false
                        //         k.children.forEach(j => {
                        //             j.checked03=false
                        //             site.push(j.country)
                        //         })
                        //     })
                        // })
                       
                          arr.forEach(p => {
                              
                            p.checked01=false
                            p.children.forEach((k,index) => {
                              
                                k.No=Math.random().toString(36).substr(2,4);
                                k.checked02=false
                                k.numType=4,
                                k.isEditor=false
                                k.editorSku=false
                                if(k.items){
                                    k.productShops.forEach(i => {
                                       let obj=k.items.find(item => item.shopid === i.shopId)
                                       if(obj){
                                           i.itemId=obj.itemId
                                           i.status=obj.status
                                       }
                                    })
                                }
                               site.push(k.country)
                            })
                        })


                        site=[...new Set(site)]
                        this.siteOptions=site.map(p => {
                            return {
                                label:p,
                                value:p
                            }
                        })
                        this.siteOptions.unshift({
                            label:'all',
                            value:'all'
                        })
                        console.log(site)
                        console.log(res.data)
                        this.childrenModel=res.data
            //    this.childrenModel = res.data
               console.log(this.childrenModel)
               this.soltstatus = true
          } else {
            this.$message.warning(res.msg);
          }
        });
    },
    productsSta(index,row){
        this.statuscode = row.template
      api
        .getProductByproductId({
          productId  : row.template,
          
        })
        .then((res) => {
          console.log(res.data);
          if (res.code == 200) {
              let arr = []
              arr.push(res.data)
              let site=[]
                        // res.data.models.forEach(p => {
                        //     p.checked01=false
                        //     p.products.forEach(k => {
                        //         k.checked02=false
                        //         k.children.forEach(j => {
                        //             j.checked03=false
                        //             site.push(j.country)
                        //         })
                        //     })
                        // })
                       
                          arr.forEach(p => {
                              
                            p.checked01=false
                            p.children.forEach((k,index) => {
                              
                                k.No=Math.random().toString(36).substr(2,4);
                                k.checked02=false
                                k.numType=4,
                                k.isEditor=false
                                k.editorSku=false
                                if(k.items){
                                    k.productShops.forEach(i => {
                                       let obj=k.items.find(item => item.shopid === i.shopId)
                                       if(obj){
                                           i.itemId=obj.itemId
                                           i.status=obj.status
                                       }
                                    })
                                }
                               site.push(k.country)
                            })
                        })


                        site=[...new Set(site)]
                        this.siteOptions=site.map(p => {
                            return {
                                label:p,
                                value:p
                            }
                        })
                        this.siteOptions.unshift({
                            label:'all',
                            value:'all'
                        })
                        console.log(site)
                        console.log(res.data)
                        this.childrenModel=res.data
            //    this.childrenModel = res.data
               console.log(this.childrenModel)
               this.soltstatus = true
          } else {
            this.$message.warning(res.msg);
          }
        });
    },//查看产品发布状态
    publishProduct(index,row){
      // console.log(row)
      //           this.SET_REGISTOR_FALSE(item)
            
      //           this.$router.push({path:'/productModel',query:{addOthers:JSON.stringify(true),idModel:row.template}})
      api
        .getProductByproductId({
          productId  : row.template,
          
        })
        .then((res) => {
          console.log(res.data);
          if (res.code == 200) {
                this.SET_REGISTOR_FALSE(res.data)
            
                this.$router.push({path:'/productModel',query:{addOthers:JSON.stringify(true),idModel:res.data.productId}})
            // console.log(row)
            //     this.SET_REGISTOR_FALSE(item)
            
            //     this.$router.push({path:'/productModel',query:{addOthers:JSON.stringify(true),idModel:row.template}})
            // this.ruleForm = res.data
            //   this.release = true
            // this.ruleForm.tiers.forEach(k => {
            //     k.checked02=false
            //     k.listItem=k.optionArray.map(k => {
            //         return {
            //             name:k,
            //             checked02:false
            //         }
            //     })
            //     if(this.ruleForm.variations.length > 0){//多规格
            //     this.radio='2'
            // }else{//单品
            //     this.radio='1'
            // }
            // })
          } else {
            this.$message.warning(res.msg);
          }
        });
    
    
      //   console.log(row)
      // console.log(this.ruleForm);
    },
    toedit(index,row){
      console.log(row);
      this.$router.push({name:'editproducts',params:{productId:row.productId}})
      // this.$router.push({name: 'b页面'，params:{userId: 123}})
    },//跳转
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pageSize4 = this.productSearchDTO.pageSize;
        this.search();
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage4 = this.productSearchDTO.pageNum;
        this.search();
      },
    auditProduct(index,row){
      console.log(row.productId);
      api
        .auditproducts({
          productLibraryId : row.productId,
          productStatus : "AUDITED"
        })
        .then((res) => {
          console.log(res);
          if (res.code == "ok") {
              this.$message.success(this.$t('other.a1406'));
              this.search();
          } else {
            this.$message.warning(res.msg);
          }
        });
    },//更改产品状态
    handleEdit(index, row) {
      console.log(index, row.productId);
      api
        .getpeodetail({
          productId: row.productId,
        })
        .then((res) => {
          console.log(res);
          if (res.code == "ok") {
            this.dialogVisible = true;
            this.proddata = res.productDetail
            this.productAttributesData = res.productDetail.productAttributes;
            this.productLogisticData = res.productDetail.productLogistic;
            this.attributeListData = res.productDetail.productSkuList;
            // console.log(this.attributeListData);
          } else {
            this.$message.warning(res.msg);
          }
        });
    },
    proBack(index,row){
        api
                          .auditproducts({
                            productLibraryId : row.productId,
                            productStatus : "CREATED"
                          })
                          .then((res) => {
                            console.log(res);
                            if (res.code == "ok") {
                                this.search();
                            } else {
                              this.$message.warning(res.msg);
                            }
                          });
    },//退回审核
    addProducts(index, row){
        console.log(row)
        if(row.template == 0){
            api
        .getpeodetail({
          productId: row.productId,
        })
        .then((res) => {
          console.log(res);
          if (res.code == "ok") {
              let obj={
                    attributes:[],
                    productShops:[],
                    categoryId:0,
                    modelId:null,
                    name: null,
                    images:[],
                    status:'NORMAL',
                    packageHeight:'',
                    description:null,
                    packageLength:'',
                    country:'ROOT',
                    packageWidth:'',
                    weight:'',
                    itemSku:null,
                    stock:null,
                    price:null,
                    hasVariation:false,
                    variations:[],
                    tiers:[],
                    logistics:[],
                    userId:this.userId,
                    sourceUrl:''
                }
        this.productDTO = res.productDetail
        let arr = res.productDetail
        obj.sourceUrl=this.ruleForm.sourceUrl
        arr.productPhotoList.forEach((p,index) => {
            obj.images.push({
                image:p,
                positions:index
            })
        })
        let image = []
        arr.productPhotoList.forEach((p,index) => {
            image.push(p)
        })
        let sku = []
        arr.productSkuList.forEach((p,index) => {
            sku.push(p.skuName)
        })
        console.log('productAttributes',this.productDTO.productAttributes);
        let NEWtiers=JSON.parse(this.productDTO.productAttributes.find(item =>  item.attributeName == "tiers").attributeValue)
        
        obj.tiers=NEWtiers.tiers
        obj.variations=NEWtiers.variations
        obj.categoryId =NEWtiers.categoryId
                
        let variations=NEWtiers.variations
        let originData=[]
        if(row.itemSkuType == 1){
            arr.productPhotoList.forEach((p,index) => {
                    obj.images.push({
                        image:p,
                        positions:index
                    })
                })
            obj.name = arr.productName
            
            obj.packageLength = arr.productLogistic.length.toString()
            obj.packageWidth = arr.productLogistic.wide.toString()
            obj.packageHeight = arr.productLogistic.height.toString()
            obj.weight = arr.productLogistic.weight.toString()
            obj.description = arr.productDescription
            obj.attributes = arr.productAttributes.map((item, index) => {
              return Object.assign(
                {},
                {
                  attributeId: Math.random().toString().substr(2, 4),
                  attributeName: item.attributeName,
                 
                  attributeValue: item.attributeValue,
                  isMandatory:false
                }
              );
            });
        }else if(row.itemSkuType == 2){
            obj.price = this.ruleForm.price
            obj.itemSku = this.ruleForm.itemSku
            obj.stock = this.ruleForm.stock
            obj.variations =variations
            obj.name = arr.productName
            
            obj.packageLength = arr.productLogistic.length==null ? 0 : arr.productLogistic.length.toString()
            obj.packageWidth = arr.productLogistic.wide==null ? 0 : arr.productLogistic.wide.toString()
            obj.packageHeight = arr.productLogistic.height==null ? 0 : arr.productLogistic.height.toString()
            obj.weight =arr.productLogistic.weight==null ? 0 :  arr.productLogistic.weight.toString()
            obj.description = arr.productDescription
            obj.attributes = arr.productAttributes.map((item, index) => {
              return Object.assign(
                {},
                {
                  attributeId: Math.random().toString().substr(2, 4),
                  attributeName: item.attributeName,
                  attributeValue: item.attributeValue,
                  isMandatory:false
                }
              )
            })
            

        }
        
                api
                .updataProduct(obj)
                .then(res => {
                    if(res.code === 200){
                        this.productDTO.template = res.data.productId
                            api
                            .updateproducts(this.productDTO)
                            .then((res) => {
                            console.log(res);
                            if (res.code == "ok") {
                                    
                            api
                            .auditproducts({
                                productLibraryId : row.productId,
                                productStatus : "AUDITED"
                            })
                            .then((res) => {
                            console.log(res);
                            if (res.code == "ok") {
                                this.search();
                            } else {
                              this.$message.warning(res.msg);
                            }
                          });
                        this.$message.success(this.$t('other.a1412'))
                    }else{
                        this.$message.warning(res.msg)
                    }
                })
                                
                                } else {
                                    this.$message.warning(res.msg);
                                }
                                });
                                        
        console.log(obj)
        } else {
            this.$message.warning(res.msg);
          }
        });
        }else{
            api
            .auditproducts({
            productLibraryId : row.productId,
            productStatus : "AUDITED"
            })
            .then((res) => {
            console.log(res);
            if (res.code == "ok") {
                this.$message.success(this.$t('other.a1413'))
                this.search();
            } else {
                this.$message.warning(res.msg);
            }
            });
        }
      
          
    },
    handleDelete(index, row) {
      console.log(index, row);
      let arr = [];
      arr.push(row.productId)
      let obj ={
        productIds:arr,
        userId : this.userId
      }
      this.$confirm(this.$t('other.a608'),this.$t("other.a142"),{
                    confirmButtonText:this.$t('other.a145'),
                    cancelButtonText: this.$t('other.a146'),
                    type: 'warning'
                }).then(() => {
                      api
        .deleteproduct(obj)
        .then((res) => {
          console.log(res);
          if (res.code == "ok") {
            this.$message.success(this.$t('other.a1232'));
            this.search();
          } else {
            this.$message.warning(res.msg);
          }
        });
                })
      
    },
    changeVaslue(){
      this.productSearchDTO.productName ='';
        this.productSearchDTO.skuName = '';
        // this.productSearchDTO.supplier = '';
        // this.productSearchDTO.wareHouse = '';
    },
    seek(){
        if(this.value == 'productName'){
          this.productSearchDTO.productName = this.input
        }else if(this.value == 'skuName'){
          this.productSearchDTO.skuName = this.input
        }else if(this.value == 'supplier'){
          this.productSearchDTO.supplier = this.input
        }else if(this.value == 'wareHouse'){
          this.productSearchDTO.wareHouse = this.input
        }
        console.log(this.productSearchDTO);
      api
        .searchproduct(this.productSearchDTO)
        .then((res) => {
          console.log(res);
          if (res.code == "ok") {
              this.tableData = res.productList;
            this.total = res.totalAmount;
          } else {
            // this.$message.warning(res.msg);
          }
        });
    },
    search() {
        
        
      api
        .searchproduct(this.productSearchDTO)
        .then((res) => {
          console.log(res);
          if (res.code == "ok") {
              this.tableData = res.productList;
            this.total = res.totalAmount;
          } else {
            // this.$message.warning(res.msg);
          }
        });
    }, //搜索产品
    getproduct() {
      api
        .getproducts({
          pageNum: this.currentPage4,
          pageSize: this.pageSize4,
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
          if (res.code == "ok") {
            this.tableData = res.productList;
            this.total = res.totalAmount;
          } else {
            this.$message.warning(res.msg);
          }
        });
    }, //获取产品列表
    renderTime(date) {
      var dateee = new Date(date).toJSON();
      return new Date(+new Date(dateee) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "");
    },
    handleClick(tab, event) {
                console.log(tab, event);
               console.log(this.activeName2)
            },

            

            fixValue(item,index){
                console.log(index)
                console.log(item.isEditor)
                item.isEditor=true
                setTimeout(() => {
                   console.log(this.$refs.children[0])
                   this.$refs.children[0].focus()
                   
                },500)
            },

            editorSku(item,index){
                console.log(index)
                console.log(item.isEditor)
                item.editorSku=true
                // setTimeout(() => {
                //    console.log(this.$refs.children[0])
                //    this.$refs.children[0].focus()
                   
                // },500)
            },

            changeItem(item,index){
                console.log(index)
               
                item.numType=4
               item.editorSku=false
                 console.log(item)
                api
                .updataProduct(item)
                .then(res => {
                    if(res.code === 200){
                       
                        this.$message.success(this.$t('other.a1414'))
                       this.getProductsta(this.statuscode)
                    }else{
                        this.$message.warning(res.msg)
                        
                    }
                }) 
            },

            KVKNG(params){
                api
                .publishProductToDXS(params)
                .then(res => {
                    if(res.code === 200){
                       this.$message.success(this.$t('other.a1303'))
                    }else{
                        this.$message.warning(res.msg)
                    }
                })
            },



            publishProduce(item){
                console.log(item)
                let text=item.status == 'DXS' ? this.$t('other.a1415') : this.$t('other.a1313') 
                this.$confirm(text,this.$t("other.a142"),{
                    confirmButtonText:this.$t('other.a145'),
                    cancelButtonText: this.$t('other.a146'),
                    type: 'warning'
                }).then(() => {
                    if(item.status == 'DXS'){
                        this.KVKNG({
                            productId:item.productId,
                            userId:this.userId,
                            online:true
                        })
                    }else{
                        api
                        .publishProducts({
                            productId:item.productId,
                            userId:this.userId
                        })
                        .then(res => {
                            if(res.code === 200){
                                let falge=false
                                 res.data.forEach(p => {
                                    this.$message.success(p.msg)
                                    if(p.msg.indexOf('上架成功') > -1) {
                                        falge=true
                                    }
                                    
                                })
    
                                if(falge){
                                    this.getParenMoel()
                                }
                            }else{
                                this.$message.warning(res.msg)
                            }
                        })
                    }


                    

                })
            },

            toVeiwId(item){
                console.log(item)
                this.$router.push({
                    path:'/mygoods/shopee',
                    query:{
                        id:item.itemId,
                        status:item.status
                    }
                })
            },

            
            getModelDetail(){
                console.log(this.modelId)
                api
                .getUserProductModel({modelId:this.modelId})
                .then(res => {
                    if(res.code === 200) {
                        console.log('modelId',res.data)
                        this.childrenModel=res.data.models
                       
                       
                    }
                })
            },

            comfrim(){
                let obj=this.mygoodslist.find(item => item.checked)
                console.log(obj.itemId)
                this.$router.push({path:'/productModel',query:{itemId:obj.itemId}})
            },
            target(index){
                console.log(index)
                let arr = []
                    arr.push(this.childrenModel)
                    console.log(arr)
                if(!index){
                    
                     arr.forEach(p => {
                        p.children.forEach(k => {
                           k.checked02=!k.checked02
                           
                        })
                      })


                }
                
               let list=[]
                arr.forEach(p => {
                    p.children.forEach(k => {
                        list.push(k)
                    })
                })
                this.targetList=list.filter(p => {
                    return p.checked02===true
                })
                console.log('99',this.targetList)
                
            
                
            },

            
             addItems(item){
                this.$router.push({path:'/productModel'})
            },

            confirmBtn(){
                console.log(this.$route.query.flag)
                if(!this.targetList.length){
                    this.$message.warning(this.$t('other.a1416'))
                    return
                }
                if(this.$route.query.flag == 'storeItemDetail'){
                     this.$router.push({
                        path:'/storeItemDetail',
                        query:{
                            productId:this.targetList[0].productId,
                            groupId:this.$route.query.groupId,
                            storeId:this.$route.query.storeId
    
                        }
                    })

                }else{

                    this.$router.push({
                        path:'/alliance/singleGoods',
                        query:{
                            productId:this.targetList[0].productId,
                            groupId:this.$route.query.groupId,
                            storeId:this.$route.query.storeId
    
                        }
                    })
                }
            },

            editor(item){
               console.log(item)
                this.SET_REGISTOR_FALSE(item)
            
                this.$router.push({path:'/pendingtrial',query:{addOthers:JSON.stringify(true),idModel:item.productId}})
               
                

                
            },

            editorChildren(item){
                this.soltstatus = false
                this.SET_REGISTOR_FALSE(item)
                this.$router.push({path:'/productModel',query:{
                    productId:JSON.stringify(item.productId),
                    country:JSON.stringify(item.country)
                }})
                console.log(item)
            },

            massEditor(item){
                console.log(item)
                this.SWITCH_LANG(this.targetList)
                let list=this.targetList.map(p => {
                    return p.productId
                })
                console.log(list)
                this.$router.push({
                    path:'/templateEditor',
                    query:{
                        lebel:JSON.stringify(item.value)
                    }
                })
            },

            createModel(){
                api
                .createProductModel({
                    modelName:this.productName,
                    userId:this.userId
                })
                .then(res => {
                    if(res.code === 200){
                        this.$message.success(this.$t('other.a1315'))
                        console.log('创建的模版',res.data)
                        this.getParenMoel()
                        this.dialogVisible=false

                    }
                })
            },

            deleteItemw(item,indexOne,index){
                this.$confirm(this.$t('other.a608'),this.$t("other.a142"),{
                    confirmButtonText:this.$t('other.a145'),
                    cancelButtonText: this.$t('other.a146'),
                    type: 'warning'
                }).then(() => {
                    console.log(item)
                    api
                    .deleteChildrenMoadel(item)
                    .then(res => {
                        if(res.code === 200){
                            this.$message.success(this.$t('other.a565'))
                        
                            this.childrenModel.splice(indexOne,1)
                        }
                    })
                })
            },

            dropdonw(item,index,index01){
                console.log(item)
                let params={
                    productId:item.productId,
                    userId:this.userId,
                    online:false
                }
                api
                .publishProductToDXS(params)
                .then(res => {
                    if(res.code === 200){
                       this.$message.success(this.$t('other.a1417'))
                    }else{
                        this.$message.warning(res.msg)
                    }
                })
            },

            deleteItemwCopy(item,indexOne,index){
                console.log(item,indexOne,index)
                this.$confirm(this.$t('other.a608'),this.$t("other.a142"),{
                    confirmButtonText:this.$t('other.a145'),
                    cancelButtonText: this.$t('other.a146'),
                    type: 'warning'
                }).then(() => {
                    console.log(item)
                    api
                    .deleteChildrenMoadel(item)
                    .then(res => {
                        if(res.code === 200){
                            this.$message.success(this.$t('other.a565'))
                            // this.init()
                            this.getProductsta(this.statuscode)
                        }
                    })
                })
            },

            
            saveChildere(item){
                item.isEditor=false
                item.editorSku=false
                 api
                .updataProduct(item)
                .then(res => {
                    if(res.code === 200){
                       
                        this.$message.success(this.$t('other.a1414'))
                       
                    }else{
                        this.$message.warning(res.msg)
                        
                    }
                })
            },

            copyItem(){
                this.mainitem.country=this.country

                 let itemCopy=JSON.parse(JSON.stringify(this.mainitem))
                itemCopy.productId=null
                itemCopy.items=[]
                itemCopy.productShops.forEach(p => {
                    p.publishNum=0
                })
                    console.log(itemCopy)
                    api
                .updataProduct(itemCopy)
                .then(res => {
                    if(res.code === 200){
                        this.$message.success(this.$t('other.a1418'))
                        this.diaTbo=false
                        this.getParenMoel()
                    }else{
                        this.$message.warning(res.msg)
                        
                    }
                })
                console.log(this.mainitem)
            },
            
            copyModel(item,children){
                console.log(item,children)
                if(children.status == 'DXS'){
                    this.diaTbo=true
                    this.mainitem=JSON.parse(JSON.stringify(children))
                }else{

                    let itemCopy=JSON.parse(JSON.stringify(children))
                    itemCopy.productId=null
                    itemCopy.items=[]
                    itemCopy.productShops.forEach(p => {
                        p.publishNum=0
                    })
                     console.log(itemCopy)
                     api
                    .updataProduct(itemCopy)
                    .then(res => {
                        if(res.code === 200){
                            console.log('复制成功！',res.data)
                            res.data.editorSku=false
                            this.$message.success(this.$t('other.a1418'))
                            // item.children.push(res.data)
                            this.getProductsta(this.statuscode)
                        }else{
                            this.$message.warning(res.msg)
                            
                        }
                    })
                }
            },

            deleteParentModel(item,indexOne){
                 this.$confirm(this.$t('other.a1419'),this.$t("other.a142"),{
                    confirmButtonText:this.$t('other.a145'),
                    cancelButtonText: this.$t('other.a146'),
                    type: 'warning'
                }).then(() => {
                    console.log(item)
                    api
                    .deleteParentMoadel(item)
                    .then(res => {
                        if(res.code === 200){
                            this.$message.success(this.$t('other.a565'))
                            setTimeout(() =>{
                                this.childrenModel.splice(indexOne,1)
                            },500)
                        }
                    })
                })
            },

            goBack(){
                if(this.$route.query.obj == '/distributeProduct/hasAgent'){
                       this.$router.push({
                           path:'/storeItemDetail',
                           query:{
                               obj:this.$route.query.obj
                           }
                       })
                      
                }
            },
			
  },
};
</script>
 
 <style lang="scss" scoped>
 .storeBox{
			border: 1px solid #eee;
			cursor: pointer;
			display:inline-block;
			margin-bottom:3px;
			padding:6px 8px;
			margin:0 3px
			
			
			
		}
    .ttpactive{
			background-color: #1890ff;
			color: #fff;
		}
	    .ttpactive:hover{
			background-color: #40a9ff;
			color: #fff;
		}
		
	
		
		.desc{
			min-width:80px
		}
      .scrollbar-wrap{
        overflow-x: hidden;
      }
      
  .order_Box{
        // margin-top: 160px;
        position: relative;

        .no_data{
            width: 100%;
            position: absolute;
            left: 0;
            right: 0;
            margin: auto;
            text-align: center;
            margin-top: 200px;


            .desc{
                font-size: 18px;
                padding: 0 10px;
            }
        }


        .item_wrapper{
        
        margin-bottom: 20px;
        box-shadow: 0 2px 1px -1px rgba(0,0,0,0.2);
        background-color: #fff;

        .nodata{
            text-align: center;
            padding: 30px 0;
        }

        .parent_item{
            height: 50px;
            line-height: 50px;
            font-size: 22px;
            border-bottom: 1px #eee solid;
            display: flex;
            justify-content: space-between;

            .parent_desc{
                margin-left: 25px;
                padding: 0 10px;
                font-size: 16px;
                color: #409eff;
                cursor: pointer;
            }
        }

        .item_header_wrapper{
          box-sizing: border-box;
          padding: 5px 10px;
          margin: 10px;
         
        }

        .item_header{
        height: 30px;
        border-bottom: 1px solid #efefef;
        line-height: 30px;
        font-size: 20px;
        padding: 5px 10px;
        color:#409eff ;
        cursor: pointer;

        .header_item{
            margin-right: 15px;
        }
        }


        .chilrder_content{
            border: 5px solid #eee;
           
            margin: 0 15px;
        }

        

        .main_content{
            box-sizing: border-box;
           
            margin: 10px 0;
            display: flex;
            border: 3px solid #eee;
          
           

            .pic_box{
             width: 80px;
             height: 80px;
        
            }

            .item_left{
                width: 30%;
                display: flex;
                border-right: 3px solid #efefef;

                .item_name{
                   box-sizing: border-box;
                    padding:0 10px;
                    flex: 1;
                }
            }

         

               


                 .item_center{
                        width: 24%;
                        border-right: 3px solid #efefef;
                        padding: 0 10px;
                        display: flex;
                        flex-direction: column;
                     
                        justify-content: space-between;


                        .desc_item{
                            padding: 5px 0;

                            .desc_item_first{
                                display: flex;
                                justify-content: space-between;
                            }

                            .item_id{
                                cursor: pointer;
                                color: #409eff;
                            }
                          

                            .copy_item{
                                cursor: pointer;
                                color: #409eff;
                            }

                            .iconItem{
                                display: inline-block;
                                width: 12px;
                                height: 12px;
                                vertical-align: middle;
                                background-color: #00c853;
                            }

                            .iconItem_copy{
                                display: inline-block;
                                width: 12px;
                                height: 12px;
                                margin: 0 5px;
                                vertical-align: middle;
                                background-color: #616161;
                            }
                        }

                        .edito_wrapper{
                            margin:0 5px;
                            color:#409eff;
                            cursor: pointer;
                            
                            font-weight: bold;
                        }

                        .changeBox{
                            margin:0 5px;
                            color:#F56C6C;
                            cursor: pointer;
                           
                            font-weight: bold;
                        }
                    }

            

           

            .item_right{
                flex:1;
                margin: 0 10px;

                .btn{
                    display: flex;
                    justify-content: flex-end;
                }
                .ttp{
                    display: flex;
                    justify-content: flex-start;
                    border-bottom: 3px solid #efefef;
                    margin: 4px 0;

                    .ttp_item:nth-child(1){
                        width: 30%;
                        border-right: 3px solid #efefef;
                       
                    }

                    .ttp_item:nth-child(2){
                        width: 30%;
                        border-right: 3px solid #efefef;
                         padding-left: 10px;
                    }

                    .ttp_item:nth-child(3){
                        width: 20%;
                        border-right: 3px solid #efefef;
                         padding-left: 10px;
                    }

                    .ttp_item:nth-child(4){
                        width: 20%;
                         padding-left: 10px;
                    }
                }
            }
        }

    }


    }
  .basic_info{
       
        background-color: #fff;
        padding: 0 16px;
        margin-bottom: 25px;

        /deep/.el-tabs__nav-scroll{
            display: flex;
            justify-content:center;
           
        }

        /deep/.el-tabs__item{
            font-size: 20px;
        }


        .attribute{
          
            min-width: 350px;
            box-sizing: border-box;
            margin-bottom: 10px;
          

            .attribute_desc{
                display: inline-block;
               
                text-align: right;
            }
        }

        .title{
            height: 68px;
            line-height: 68px;
            font-size: 20px;
            font-weight: 500;
            letter-spacing: .02em!important;
            font-family: Roboto,sans-serif!important;
            border-bottom: 1px solid #eee;
        }

        .basic_detail{
            padding: 15px 0;

            .singSku_wrapper{
                display: flex;

                .singSku{
                display: flex;
                margin-right: 30px;

                .inputBox{
                    display: inline-block;
                    width: 180px;
                }
            }
            }

            .attribute{
                width:100%;
                height:auto;
               
                box-sizing: border-box;
                padding:5px 10px;


                .fist_title_wrapper{
                    border-bottom: 1px solid #eee;
                    display: flex;
                    justify-content: space-between;
                    .fist_title{
                    
                    font-weight: bold;
                    font-size: 18px;
                    
                }
                }

                .category_item{
                    margin: 0 15px;

                    .el-icon-circle-close{
                        font-weight: bold;
                        font-size: 18px;
                        color: red;
                        margin: 0 8px;
                        cursor: pointer;
                    }

                    .el-icon-edit{
                        cursor: pointer;
                    }


                    
                }

                .el-icon-edit{
                    padding: 0 10px;
                }

                

                


            }

            
        }

        .listitem{
            
            display: inline-block;
            width: 120px;
            height: 120px;
            border-radius: 3px;
            cursor: pointer;
            border: 1px dashed #c0ccda;
            margin: 0 5px;
            position: relative;
        }

        .pic_desc{
            position: absolute;
            bottom: -45px;
            left: 40px;
        }

        .cateGory_wrapper{
            position: relative;
            box-shadow:0 5px 5px -3px #606266;
            height: 450px;
            
            

            
            .first_wrapper{
                position: absolute;
                top: 0;
                left: 0;
                width: 200px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;
               

                .first_category{
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }
                
            
            }

            

            .second_wrapper{
                position: absolute;
                top: 0;
                left: 200px;
                width: 200px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;
               

                .second_category{
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }
               

            }

            .three_wrapper{
                position: absolute;
                top: 0;
                left: 400px;
                width: 200px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;

                 .three_category{
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }
               

            }

            .four_wrapper{
                position: absolute;
                top: 0;
                left: 600px;
                width: 200px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;

                 .four_category{
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }
               

            }

            .five_wrapper{
                position: absolute;
                top: 0;
                left: 800px;
                width: 200px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;

                 .five_category{
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }
               

            }


            .category_title{
                position: relative;
                top: 0;
                left: 0;
               
            }

            .active{
                background-color: #fff;
            }

          

            .active:hover{
                background-color: #eee;
            }
        }

        .pic_box{
          
            width: 120px;
            height: 120px;
            position: absolute;
            z-index: 2;
        }

        .listitem::after {
            content: "+";
            font-size: 40px;
           
            position: absolute;
            top: 48px;
            left: 48px;
            z-index: 1;

          
        }

        .delete{
           
            width: 120px;
            background-color: rgba(0,0,0,.87);
            color: #fff;
            position: absolute;
            bottom: 0;
            left: 0;
            text-align: center;
            display: none;
            z-index:99

        }

        .deleteActive{
            display: block;
            z-index:99
        }

   

        .icon-zengjiatianjiajiajian{
            color: rgb(64, 211, 242);
            cursor: pointer;
            font-size: 20px;
        }

        .icon-jianshao1{
            color: rgb(246, 97, 109);
            cursor: pointer;
            font-size: 20px;
        }


     
    }
 .productionModel{
    // background-color: #eee;
    box-sizing: border-box;
    padding: 0 20px;
    margin-bottom: 60px;
    
 }
 .activecss{
   display: flex;
   align-items: center;
   justify-content: space-between;
 }
.title{
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  width: 100%;
            height: 68px;
            line-height: 68px;
            font-size: 20px;
            font-weight: 500;
            letter-spacing: .02em!important;
            font-family: Roboto,sans-serif!important;
            border-bottom: 1px solid #eee;
        }
 .block{
   position: fixed;
   bottom: 12px;
   right: 12px;
 }
.home_body {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;

  margin: 10px;
  margin-bottom: 150px;
}
.order_time {
  font-size: 13px;
}
.order_time_s{
  width: 100%;
  height: 70px;
  display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 3;
overflow: hidden;
}
</style>